var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// src/common/index.ts
var common_exports = {};
__export(common_exports, {
  Console: () => Console,
  LogLevel: () => LogLevel,
  copyToClipboard: () => copyToClipboard,
  injectWidget: () => injectWidget,
  listenToDataFromWidgets: () => listenToDataFromWidgets,
  logger: () => logger2,
  modifyWidget: () => modifyWidget,
  removeAjaxRequestListener: () => removeAjaxRequestListener,
  removeListener: () => removeListener,
  removeWebRequestListener: () => removeWebRequestListener,
  removeWidget: () => removeWidget,
  removeXhrListener: () => removeXhrListener,
  sendDataToWidget: () => sendDataToWidget,
  sendExtensionLog: () => sendExtensionLog,
  storageGet: () => storageGet,
  storageRemove: () => storageRemove,
  storageSet: () => storageSet
});

// src/common/connectors.ts
import { Standard } from "@getvim/vim-connect";

// src/common/types.ts
var LogLevel = /* @__PURE__ */ ((LogLevel2) => {
  LogLevel2["DEBUG"] = "debug";
  LogLevel2["INFO"] = "info";
  LogLevel2["WARNING"] = "warning";
  LogLevel2["ERROR"] = "error";
  LogLevel2["CRITICAL"] = "critical";
  return LogLevel2;
})(LogLevel || {});

// src/messaging.ts
var messaging_exports = {};
__export(messaging_exports, {
  LISTEN_ONCE_TTL: () => LISTEN_ONCE_TTL,
  sendAsyncMessage: () => sendAsyncMessage,
  sendMessage: () => sendMessage,
  sendMessageWithHandler: () => sendMessageWithHandler
});
import { SyncExtensionConnectorTimeoutError } from "@getvim/vim-connect/src/standard/errors/sync-extension-connector-timeout-error";
import { v4 as uuid } from "uuid";
import { logger } from "@getvim/vim-connect-logger";

// src/parentChannelProvider.ts
var parentChannelProviderInstance = class {
  sendMessage(message) {
    const parentPort = window?.$vimConnectParentPort || window?.$barebonePort;
    if (parentPort) {
      parentPort.postMessage(message);
      return;
    } else {
      window.parent.postMessage(message, "*");
    }
  }
};
var parentChannelProvider = new parentChannelProviderInstance();

// src/messaging.ts
var ACK_MESSAGE_TYPE = "vim-connect-message-channel-ack";
var priority = 0;
var ws;
var getTabIdFromUrl = () => {
  const url = new URL(window.location.href);
  const tabId = url.searchParams.get("tabId");
  return tabId ? Number(tabId) : void 0;
};
var record = (type, data) => {
  try {
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.get("record") === "true") {
      logger.scope(`recorder-${type}`).debug(`${type} message ${data.type} priority= ${priority}`, data);
      if (!ws) {
        ws = new WebSocket(`ws://localhost:6022/ws/record/records-stream`);
        ws.addEventListener("close", () => {
          logger.scope("recorder").debug("vsCode closed connection... won't send new messages");
        });
      }
      const wsPayload = JSON.stringify({
        type,
        priority: priority++,
        timestamp: Date.now(),
        data
      });
      if (ws.readyState !== ws.OPEN && ws.readyState !== ws.CLOSED) {
        ws.addEventListener("open", () => {
          ws?.send(wsPayload);
        });
      } else if (ws.readyState !== ws.CLOSED) {
        ws.send(wsPayload);
      }
    }
  } catch (e) {
    logger.scope("recorder").debug("failed to send recording", { error: e });
  }
};
var listenersMap = /* @__PURE__ */ new Map();
var listenersToTypeMap = /* @__PURE__ */ new Map();
function listener(message) {
  const { response, error, messageId } = message?.data ?? {};
  if (!messageId) {
    return;
  }
  if (message?.data?.type === ACK_MESSAGE_TYPE) {
    const listener2 = listenersMap.get(messageId);
    if (listener2) {
      listener2.ackResponse = {
        ...listener2.ackResponse,
        ...message.data
      };
      listenersMap.set(messageId, listener2);
    }
    return;
  }
  const handler = listenersMap.get(messageId);
  const type = listenersToTypeMap.get(messageId);
  if (type) {
    record(type?.isWithHandler ? "single-stream-response-to-adapter" : "response-to-adapter", {
      type: type?.value,
      messageId,
      response,
      error
    });
    listenersToTypeMap.delete(messageId);
  }
  if (handler) {
    if (!error) {
      handler.resolve(response, message?.ports);
    } else {
      (handler.reject ?? handler.resolve)(response);
    }
    handler.reject && listenersMap.delete(messageId);
    handler.timeoutId && clearInterval(handler.timeoutId);
  }
}
window.addEventListener("message", listener);
var LISTEN_ONCE_TTL = 3e4;
function listenOnce(id, type, payload, timeout = LISTEN_ONCE_TTL) {
  return new Promise((resolve, reject) => {
    const timeoutId = setTimeout(() => {
      const handler = listenersMap.get(id);
      if (handler) {
        const listener2 = listenersMap.get(id);
        listenersMap.delete(id);
        reject(new SyncExtensionConnectorTimeoutError(type, payload, timeout, id, listener2?.ackResponse));
      }
    }, timeout);
    const ackResponse = {
      sendTime: Date.now(),
      ackReceived: false
    };
    listenersMap.set(id, { resolve, reject, timeoutId, ackResponse });
  });
}
function listenMany(id, handler) {
  listenersMap.set(id, { resolve: handler });
}
function sendAsyncMessage({ type, payload }) {
  const messageId = uuid();
  record("from-adapter", { type, messageId, response: payload });
  const ehrInstanceId = getTabIdFromUrl();
  parentChannelProvider.sendMessage({
    type,
    payload,
    messageId,
    ehrInstanceId,
    isAsyncMessage: true
  });
}
function sendMessage({
  type,
  payload,
  timeout,
  ehrInstanceId
}) {
  const messageId = uuid();
  const finalEhrInstanceId = ehrInstanceId || getTabIdFromUrl();
  const promise = listenOnce(messageId, type, payload, timeout);
  listenersToTypeMap.set(messageId, { value: type, isWithHandler: false });
  record("from-adapter", { type, messageId, payload });
  parentChannelProvider.sendMessage({
    type,
    payload,
    messageId,
    ehrInstanceId: finalEhrInstanceId,
    sendStartTimeStamp: Date.now(),
    shouldSendAck: true
  });
  return promise;
}
function sendMessageWithHandler({
  type,
  payload,
  handler
}) {
  if (!(handler instanceof Function)) {
    logger.scope("DEV").error("Invalid usage of send message with handler", { type, payload, handler });
    throw new Error("Invalid handler, handler must be a function");
  }
  return new Promise((resolve, reject) => {
    const messageId = uuid();
    const ehrInstanceId = getTabIdFromUrl();
    listenOnce(messageId, type, payload).then((response) => {
      listenersToTypeMap.set(messageId, { value: type, isWithHandler: true });
      listenMany(messageId, handler);
      resolve(response);
    }).catch(reject);
    record("from-adapter-stream-listen", { type, messageId, payload });
    parentChannelProvider.sendMessage({
      type,
      payload,
      messageId,
      ehrInstanceId,
      shouldSendAck: true
    });
  });
}

// src/common/connectors.ts
var CommonConnectorMessageTypes = Standard.Connectors.Common.CommonConnectorMessageTypes;
function copyToClipboard(payload) {
  return sendMessage({
    type: "copyToClipboard",
    payload
  });
}
function removeListener({ listenerId }) {
  return sendMessage({
    type: "removeListener",
    payload: { listenerId }
  });
}
function removeXhrListener({ listenerId }) {
  return sendMessage({
    type: "removeXhrListener",
    payload: { listenerId }
  });
}
function removeWebRequestListener({ listenerId }) {
  return sendMessage({
    type: "removeWebRequestListener",
    payload: { listenerId }
  });
}
function removeAjaxRequestListener({ listenerId }) {
  return sendMessage({
    type: "removeAjaxRequestListener",
    payload: { listenerId }
  });
}
function sendExtensionLog({ message, data, logLevel, logToBackend }) {
  return sendMessage({
    type: "sendExtensionLog",
    payload: { message, data, logLevel, logToBackend }
  });
}
function storageGet({
  key
}) {
  return sendMessage({
    type: CommonConnectorMessageTypes.chromeStorageGet,
    payload: { key }
  });
}
function storageSet({
  data
}) {
  return sendMessage({
    type: CommonConnectorMessageTypes.chromeStorageSet,
    payload: { data }
  });
}
function storageRemove({
  key
}) {
  return sendMessage({
    type: CommonConnectorMessageTypes.chromeStorageRemove,
    payload: { key }
  });
}
function injectWidget({ selector, frameSelector, widget }) {
  return sendMessage({
    type: "injectWidget",
    payload: { selector, frameSelector, widget }
  });
}
function removeWidget(widgetId) {
  return sendMessage({
    type: "removeWidget",
    payload: { widgetId }
  });
}
function sendDataToWidget({ widgetId, payload }) {
  return sendMessage({
    type: "sendDataToWidget",
    payload: { widgetId, payload }
  });
}
function modifyWidget({ widget }) {
  return sendMessage({
    type: "modifyWidget",
    payload: { widget }
  });
}
async function listenToDataFromWidgets(handler) {
  const listenerId = await sendMessageWithHandler({
    type: "listenToDataFromWidgets",
    handler
  });
  return listenerId ? { remove: () => removeListener({ listenerId }), listenerId } : false;
}
var logger2 = {
  info: (message, data) => sendExtensionLog({
    message,
    data,
    logLevel: "info" /* INFO */,
    logToBackend: true
  }),
  error: (message, data) => sendExtensionLog({
    message,
    data,
    logLevel: "error" /* ERROR */,
    logToBackend: true
  }),
  warning: (message, data) => sendExtensionLog({
    message,
    data,
    logLevel: "warning" /* WARNING */,
    logToBackend: true
  }),
  debug: (message, data) => sendExtensionLog({
    message,
    data,
    logLevel: "debug" /* DEBUG */,
    logToBackend: true
  })
};
var Console = {
  log: (message) => sendMessage({
    type: "consoleMessage",
    payload: { message, level: "log" }
  }),
  warn: (message) => sendMessage({
    type: "consoleMessage",
    payload: { message, level: "warn" }
  }),
  error: (message) => sendMessage({
    type: "consoleMessage",
    payload: { message, level: "error" }
  }),
  info: (message) => sendMessage({
    type: "consoleMessage",
    payload: { message, level: "info" }
  }),
  debug: (message) => sendMessage({
    type: "consoleMessage",
    payload: { message, level: "debug" }
  })
};

// src/desktop/index.ts
var desktop_exports = {};
__export(desktop_exports, {
  Console: () => Console,
  DiagnosisSetType: () => DiagnosisSetType,
  DllType: () => DllType,
  FileManagerOperationType: () => FileManagerOperationType,
  LogLevel: () => LogLevel,
  MissingDesktopWindowError: () => MissingDesktopWindowError,
  NextGenOpsRequestType: () => NextGenOpsRequestType,
  ProcessNotFoundError: () => ProcessNotFoundError,
  SqlParameterType: () => SqlParameterType,
  UIA_PropertyIds: () => UIA_PropertyIds,
  VersionExtractsEhrUrlFromFilePath: () => VersionExtractsEhrUrlFromFilePath,
  VersionSupportsProcessFileInfo: () => VersionSupportsProcessFileInfo,
  Win32DeprecationManager: () => Win32DeprecationManager,
  Win32GetIeWindowUrl: () => Win32GetIeWindowUrl,
  WindowNotFoundError: () => WindowNotFoundError,
  WindowsAgent: () => WindowsAgent,
  WindowsAgentTypes: () => types_exports,
  WriteBackType: () => WriteBackType,
  addAccessControlAllowOrigin: () => addAccessControlAllowOrigin,
  addAntiProxyPipeToState: () => addAntiProxyPipeToState,
  addBrowserWindowEventListener: () => addBrowserWindowEventListener,
  addIncognitoToExtension: () => addIncognitoToExtension,
  addSessionCookie: () => addSessionCookie,
  addUrlToListen: () => addUrlToListen,
  addWindowToListen: () => addWindowToListen,
  addWindowsToListenV2: () => addWindowsToListenV2,
  changeWindowsVisibility: () => changeWindowsVisibility,
  clearFetchSessions: () => clearFetchSessions,
  clearSessionCookie: () => clearSessionCookie,
  clearSessionCookies: () => clearSessionCookies,
  closeEhrWindows: () => closeEhrWindows,
  copyToClipboard: () => copyToClipboard,
  createBrowserWindow: () => createBrowserWindow,
  createSSOWindow: () => createSSOWindow,
  destroyBrowserWindow: () => destroyBrowserWindow,
  disableVimOSInteraction: () => disableVimOSInteraction,
  disconnectAntiProxyPipe: () => disconnectAntiProxyPipe,
  doesProcessExists: () => doesProcessExists,
  enableVimOSInteraction: () => enableVimOSInteraction,
  fetchBase64ThroughNode: () => fetchBase64ThroughNode,
  fetchSessionGet: () => fetchSessionGet,
  fetchThroughNode: () => fetchThroughNode,
  getActiveWindow: () => getActiveWindow,
  getActiveWindowDetails: () => getActiveWindowDetails,
  getAgentVersion: () => getAgentVersion,
  getAllEhrCookies: () => getAllEhrCookies,
  getAllEhrCookiesAsync: () => getAllEhrCookiesAsync,
  getBrowserWindowDetails: () => getBrowserWindowDetails,
  getChromeProfiles: () => getChromeProfiles,
  getComputerIdleState: () => getComputerIdleState,
  getCurrentVersion: () => getCurrentVersion,
  getDMRFlags: () => getDMRFlags,
  getEhrProcessPath: () => getEhrProcessPath,
  getEhrVersion: () => getEhrVersion,
  getEnvironmentVariable: () => getEnvironmentVariable,
  getFileContentsById: () => getFileContentsById,
  getFileInfoByPID: () => getFileInfoByPID,
  getFlexgridValues: () => getFlexgridValues,
  getImageVersionByImageName: () => getImageVersionByImageName,
  getLoginState: () => getLoginState,
  getNextgenStatusBarData: () => getNextgenStatusBarData,
  getOsVersion: () => getOsVersion,
  getTaskListByProcessList: () => getTaskListByProcessList,
  healthCheckWin32: () => healthCheckWin32,
  initSession: () => initSession,
  injectDesktopInlineWidget: () => injectDesktopInlineWidget,
  injectDllToProcessElectorn: () => injectDllToProcessElectorn,
  injectWidget: () => injectWidget,
  invokeBrowserWindowMethod: () => invokeBrowserWindowMethod,
  isMSIVersionGreaterOrEqual: () => isMSIVersionGreaterOrEqual,
  isProcessRunningByName: () => isProcessRunningByName,
  listenToDataFromAntiProxy: () => listenToDataFromAntiProxy,
  listenToDataFromEhr: () => listenToDataFromEhr,
  listenToDataFromGlobalShortcut: () => listenToDataFromGlobalShortcut,
  listenToDataFromIpc: () => listenToDataFromIpc,
  listenToDataFromSqlListener: () => listenToDataFromSqlListener,
  listenToDataFromWidgets: () => listenToDataFromWidgets,
  logger: () => logger2,
  modifyEcwPlugin: () => modifyEcwPlugin,
  modifyWidget: () => modifyWidget,
  nextGenCheckEncounterDrugInteractions: () => nextGenCheckEncounterDrugInteractions,
  nextGenCreateEncounterDocument: () => nextGenCreateEncounterDocument,
  nextGenGetDBCredentials: () => nextGenGetDBCredentials,
  nextGenGetEncounter: () => nextGenGetEncounter,
  nextGenSearchDiagnosis: () => nextGenSearchDiagnosis,
  nextGenSetEncounter: () => nextGenSetEncounter,
  readDirectory: () => readDirectory,
  readHostFile: () => readHostFile,
  recreateWin32Pipe: () => recreateWin32Pipe,
  removeAjaxRequestListener: () => removeAjaxRequestListener,
  removeFile: () => removeFile,
  removeListener: () => removeListener,
  removeListenerToDataFromGlobalShortcut: () => removeListenerToDataFromGlobalShortcut,
  removeWebRequestListener: () => removeWebRequestListener,
  removeWidget: () => removeWidget,
  removeXhrListener: () => removeXhrListener,
  sendAndReceiveDataFromSql: () => sendAndReceiveDataFromSql,
  sendAndReceiveDataFromSqlTunnel: () => sendAndReceiveDataFromSqlTunnel,
  sendAndReceiveDataFromWin32: () => sendAndReceiveDataFromWin32,
  sendAndReceiveMfcData: () => sendAndReceiveMfcData,
  sendCloseAll: () => sendCloseAll,
  sendDataToProxy: () => sendDataToProxy,
  sendDataToWidget: () => sendDataToWidget,
  sendDoneGracefulShutdown: () => sendDoneGracefulShutdown,
  sendEhrProcessNameToWin32: () => sendEhrProcessNameToWin32,
  sendExtensionLog: () => sendExtensionLog,
  sendMessageToAntiProxy: () => sendMessageToAntiProxy,
  sendMessageToIpcAsync: () => sendMessageToIpcAsync,
  sendProcessSettings: () => sendProcessSettings,
  setFlexgridValues: () => setFlexgridValues,
  setRuntimeCookie: () => setRuntimeCookie,
  setTrayState: () => setTrayState,
  shouldLockToLTS: () => shouldLockToLTS,
  sockets: () => sockets,
  sqlTunnelDisconnect: () => sqlTunnelDisconnect,
  sqlTunnelEnforceGetOne: () => sqlTunnelEnforceGetOne,
  sqlTunnelGet: () => sqlTunnelGet,
  sqlTunnelGetOne: () => sqlTunnelGetOne,
  sqlTunnelInitialize: () => sqlTunnelInitialize,
  startIntegrationTool: () => startIntegrationTool,
  stopIntegrationTool: () => stopIntegrationTool,
  storageGet: () => storageGet,
  storageRemove: () => storageRemove,
  storageSet: () => storageSet,
  test_clear_current_version: () => test_clear_current_version,
  textVersionSupportsStatelessNodeFetch: () => textVersionSupportsStatelessNodeFetch,
  triggerAdapterRefresh: () => triggerAdapterRefresh,
  triggerInjectDllToProcess: () => triggerInjectDllToProcess,
  uiaHasChildren: () => uiaHasChildren2,
  uploadFile: () => uploadFile,
  versionSupportRobustInitializedConnection: () => versionSupportRobustInitializedConnection,
  versionSupportUseProcessExistsFromElectron: () => versionSupportUseProcessExistsFromElectron,
  versionSupportWindowWatcherWithInstanceId: () => versionSupportWindowWatcherWithInstanceId,
  versionSupportsBase64NodeFetch: () => versionSupportsBase64NodeFetch,
  versionSupportsDebugDllInjection: () => versionSupportsDebugDllInjection,
  versionSupportsDeletingEcwPluginProducts: () => versionSupportsDeletingEcwPluginProducts,
  versionSupportsDllInjectionIdentifier: () => versionSupportsDllInjectionIdentifier,
  versionSupportsEcwEncryptionV2: () => versionSupportsEcwEncryptionV2,
  versionSupportsEcwPluginInjection: () => versionSupportsEcwPluginInjection,
  versionSupportsEcwPluginModification: () => versionSupportsEcwPluginModification,
  versionSupportsElectronDllInjection: () => versionSupportsElectronDllInjection,
  versionSupportsExtendEnvVars: () => versionSupportsExtendEnvVars,
  versionSupportsExtractEcwEncryptionKey: () => versionSupportsExtractEcwEncryptionKey,
  versionSupportsFixedGetDomElement: () => versionSupportsFixedGetDomElement,
  versionSupportsFlexGridDll: () => versionSupportsFlexGridDll,
  versionSupportsForcedIntegrationToolKill: () => versionSupportsForcedIntegrationToolKill,
  versionSupportsFullIntegrationToolManager: () => versionSupportsFullIntegrationToolManager,
  versionSupportsGetComputerIdle: () => versionSupportsGetComputerIdle,
  versionSupportsGetImageVersionByName: () => versionSupportsGetImageVersionByName,
  versionSupportsGetOrganizationByKey: () => versionSupportsGetOrganizationByKey,
  versionSupportsGetTaskListByProcessList: () => versionSupportsGetTaskListByProcessList,
  versionSupportsInjectDllService: () => versionSupportsInjectDllService,
  versionSupportsIntegrationToolManager: () => versionSupportsIntegrationToolManager,
  versionSupportsInternetCookies: () => versionSupportsInternetCookies,
  versionSupportsIsElementEnabled: () => versionSupportsIsElementEnabled,
  versionSupportsMultiProcess: () => versionSupportsMultiProcess,
  versionSupportsNewAntiProxyDll: () => versionSupportsNewAntiProxyDll,
  versionSupportsNewGetDomElementFunction: () => versionSupportsNewGetDomElementFunction,
  versionSupportsNewNextgenDll: () => versionSupportsNewNextgenDll,
  versionSupportsNewNextgenLoginDetection: () => versionSupportsNewNextgenLoginDetection,
  versionSupportsNewWinCryptNextgenDll: () => versionSupportsNewWinCryptNextgenDll,
  versionSupportsNextgenEncounter: () => versionSupportsNextgenEncounter,
  versionSupportsNextgenPrintEncounter: () => versionSupportsNextgenPrintEncounter,
  versionSupportsNextgenSearchAndDrugInteractions: () => versionSupportsNextgenSearchAndDrugInteractions,
  versionSupportsRecreateWin32Ipcs: () => versionSupportsRecreateWin32Ipcs,
  versionSupportsRemoteBrowserWindows: () => versionSupportsRemoteBrowserWindows,
  versionSupportsSetTrayStates: () => versionSupportsSetTrayStates,
  versionSupportsSqlQueriesListener: () => versionSupportsSqlQueriesListener,
  versionSupportsStatelessNodeFetch: () => versionSupportsStatelessNodeFetch,
  versionSupportsStatusBarNextgen: () => versionSupportsStatusBarNextgen,
  versionSupportsStopOnCriticalFail: () => versionSupportsStopOnCriticalFail,
  versionSupportsTogglingIncognito: () => versionSupportsTogglingIncognito,
  versionSupportsV2Adapter: () => versionSupportsV2Adapter,
  versionSupportsVimOs: () => versionSupportsVimOs,
  versionSupportsWin32IntegrationToolManager: () => versionSupportsWin32IntegrationToolManager,
  versionSupportsWincryptDetours: () => versionSupportsWincryptDetours,
  versionSupportsWindowsAgentHealthCheck: () => versionSupportsWindowsAgentHealthCheck,
  versionSupportsWindowsAgentWin32: () => versionSupportsWindowsAgentWin32,
  versionSupportsWindowsAgentWin32TypedResponses: () => versionSupportsWindowsAgentWin32TypedResponses,
  versionSupportsWindowsAgentWriteback: () => versionSupportsWindowsAgentWriteback,
  versionSupposedWindowsAgentProcessEnum: () => versionSupposedWindowsAgentProcessEnum,
  win32CloseWindow: () => win32CloseWindow,
  win32DecodeEcwPassword: () => win32DecodeEcwPassword,
  win32DecodeEcwPasswordV305: () => win32DecodeEcwPasswordV305,
  win32ExtractEcwEncryptionKey: () => win32ExtractEcwEncryptionKey,
  win32ExtractEcwEncryptionKeyV305: () => win32ExtractEcwEncryptionKeyV305,
  win32GetChildProcesses: () => win32GetChildProcesses,
  win32GetChildValues: () => win32GetChildValues,
  win32GetControlsValues: () => win32GetControlsValues,
  win32GetCursorHighlightedWindow: () => win32GetCursorHighlightedWindow,
  win32GetDomElement: () => win32GetDomElement,
  win32GetForegroundWindow: () => win32GetForegroundWindow,
  win32GetProcessAttributes: () => win32GetProcessAttributes,
  win32GetProcessExists: () => win32GetProcessExists,
  win32GetWindowAttributes: () => win32GetWindowAttributes,
  win32GetWindowByCriteria: () => win32GetWindowByCriteria,
  win32GetWindowText: () => win32GetWindowText,
  win32GetWindows: () => win32GetWindows,
  win32IsElementEnabled: () => win32IsElementEnabled,
  win32WaitForWindowV2: () => win32WaitForWindowV2,
  win32WriteBackAction: () => win32WriteBackAction,
  win32WriteBackActionSync: () => win32WriteBackActionSync,
  win32waitForWindows: () => win32waitForWindows,
  windowsAgent: () => windowsAgent,
  windowsAgentWaitForWindow: () => windowsAgentWaitForWindow,
  windowsAgentwin32waitForWindows: () => windowsAgentwin32waitForWindows,
  wrappedErrorIfIsOfTypeWinNotFound: () => wrappedErrorIfIsOfTypeWinNotFound
});

// src/desktop/connectors.ts
import { v4 as uuid2 } from "uuid";
import { logger as LoggerImport7 } from "@getvim/vim-connect-logger";
import { retry as retry2 } from "@vim/promise";
import { SyncExtensionConnectorTimeoutError as SyncExtensionConnectorTimeoutError2 } from "@getvim/vim-connect/src/standard/errors/sync-extension-connector-timeout-error";

// src/desktop/windows-agent/hub.ts
import { logger as LoggerImport } from "@getvim/vim-connect-logger";
var Hub = class {
  constructor(messenger) {
    this.messenger = messenger;
  }
  channels = {};
  channel(name) {
    if (!this.channels[name]) {
      this.channels[name] = createProxyChannel(name, this.messenger);
    }
    return this.channels[name];
  }
};
var createProxyChannel = (name, messenger) => {
  const logger4 = LoggerImport.scope(`infra/extension-connector/desktop/windows-agent/hub`);
  return new Proxy({}, {
    get: (_, method) => {
      if (typeof method !== "string") {
        logger4.error(`Given method for ${name} has invalid type of ${typeof method}`, {});
        return void 0;
      }
      if (method == "on") {
        return (event, listener2) => {
          messenger.on(event, listener2);
        };
      }
      return (...args) => {
        return messenger.send({
          payload: {
            methodName: toPascalCase(method),
            arguments: args,
            channelName: name
          }
        });
      };
    }
  });
};
var toPascalCase = (value) => value[0].toUpperCase() + value.substring(1);

// src/desktop/windows-agent/messaging/messenger.ts
var UIA_PropertyIds = /* @__PURE__ */ ((UIA_PropertyIds2) => {
  UIA_PropertyIds2["UIA_RuntimeIdPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_BoundingRectanglePropertyId"] = "UIA_BoundingRectanglePropertyId";
  UIA_PropertyIds2["UIA_ProcessIdPropertyId"] = "UIA_ProcessIdPropertyId";
  UIA_PropertyIds2["UIA_ControlTypePropertyId"] = "UIA_ControlTypePropertyId";
  UIA_PropertyIds2["UIA_LocalizedControlTypePropertyId"] = "UIA_LocalizedControlTypePropertyId";
  UIA_PropertyIds2["UIA_NamePropertyId"] = "UIA_NamePropertyId";
  UIA_PropertyIds2["UIA_AcceleratorKeyPropertyId"] = "UIA_AcceleratorKeyPropertyId";
  UIA_PropertyIds2["UIA_AccessKeyPropertyId"] = "UIA_AccessKeyPropertyId";
  UIA_PropertyIds2["UIA_HasKeyboardFocusPropertyId"] = "UIA_HasKeyboardFocusPropertyId";
  UIA_PropertyIds2["UIA_IsKeyboardFocusablePropertyId"] = "UIA_IsKeyboardFocusablePropertyId";
  UIA_PropertyIds2["UIA_IsEnabledPropertyId"] = "UIA_IsEnabledPropertyId";
  UIA_PropertyIds2["UIA_AutomationIdPropertyId"] = "UIA_AutomationIdPropertyId";
  UIA_PropertyIds2["UIA_ClassNamePropertyId"] = "UIA_ClassNamePropertyId";
  UIA_PropertyIds2["UIA_HelpTextPropertyId"] = "UIA_HelpTextPropertyId";
  UIA_PropertyIds2["UIA_ClickablePointPropertyId"] = "UIA_ClickablePointPropertyId";
  UIA_PropertyIds2["UIA_CulturePropertyId"] = "UIA_CulturePropertyId";
  UIA_PropertyIds2["UIA_IsControlElementPropertyId"] = "UIA_IsControlElementPropertyId";
  UIA_PropertyIds2["UIA_IsContentElementPropertyId"] = "UIA_IsContentElementPropertyId";
  UIA_PropertyIds2["UIA_LabeledByPropertyId"] = "UIA_LabeledByPropertyId";
  UIA_PropertyIds2["UIA_IsPasswordPropertyId"] = "UIA_IsPasswordPropertyId";
  UIA_PropertyIds2["UIA_NativeWindowHandlePropertyId"] = "UIA_NativeWindowHandlePropertyId";
  UIA_PropertyIds2["UIA_IsOffscreenPropertyId"] = "UIA_IsOffscreenPropertyId";
  UIA_PropertyIds2["UIA_OrientationPropertyId"] = "UIA_OrientationPropertyId";
  UIA_PropertyIds2["UIA_FrameworkIdPropertyId"] = "UIA_FrameworkIdPropertyId";
  UIA_PropertyIds2["UIA_IsRequiredForFormPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_ItemStatusPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_IsDockPatternAvailablePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_IsExpandCollapsePatternAvailablePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_IsGridItemPatternAvailablePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_IsGridPatternAvailablePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_IsInvokePatternAvailablePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_IsMultipleViewPatternAvailablePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_IsRangeValuePatternAvailablePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_IsScrollPatternAvailablePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_IsScrollItemPatternAvailablePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_IsSelectionItemPatternAvailablePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_IsSelectionPatternAvailablePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_IsTablePatternAvailablePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_IsTableItemPatternAvailablePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_IsTextPatternAvailablePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_IsTogglePatternAvailablePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_IsTransformPatternAvailablePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_IsValuePatternAvailablePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_IsWindowPatternAvailablePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_ValueValuePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_ValueIsReadOnlyPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_RangeValueValuePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_RangeValueIsReadOnlyPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_RangeValueMinimumPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_RangeValueMaximumPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_RangeValueLargeChangePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_RangeValueSmallChangePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_ScrollHorizontalScrollPercentPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_ScrollHorizontalViewSizePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_ScrollVerticalScrollPercentPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_ScrollVerticalViewSizePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_ScrollHorizontallyScrollablePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_ScrollVerticallyScrollablePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_SelectionSelectionPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_SelectionCanSelectMultiplePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_SelectionIsSelectionRequiredPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_GridRowCountPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_GridColumnCountPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_GridItemRowPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_GridItemColumnPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_GridItemRowSpanPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_GridItemColumnSpanPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_GridItemContainingGridPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_DockDockPositionPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_ExpandCollapseExpandCollapseStatePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_MultipleViewCurrentViewPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_MultipleViewSupportedViewsPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_WindowCanMaximizePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_WindowCanMinimizePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_WindowWindowVisualStatePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_WindowWindowInteractionStatePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_WindowIsModalPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_WindowIsTopmostPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_SelectionItemIsSelectedPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_SelectionItemSelectionContainerPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_TableRowHeadersPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_TableColumnHeadersPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_TableRowOrColumnMajorPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_TableItemRowHeaderItemsPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_TableItemColumnHeaderItemsPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_ToggleToggleStatePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_TransformCanMovePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_TransformCanResizePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_TransformCanRotatePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_IsLegacyIAccessiblePatternAvailablePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_LegacyIAccessibleChildIdPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_LegacyIAccessibleNamePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_LegacyIAccessibleValuePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_LegacyIAccessibleDescriptionPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_LegacyIAccessibleRolePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_LegacyIAccessibleStatePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_LegacyIAccessibleHelpPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_LegacyIAccessibleKeyboardShortcutPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_LegacyIAccessibleSelectionPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_LegacyIAccessibleDefaultActionPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_AriaRolePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_AriaPropertiesPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_IsDataValidForFormPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_ControllerForPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_DescribedByPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_FlowsToPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_ProviderDescriptionPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_IsItemContainerPatternAvailablePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_IsVirtualizedItemPatternAvailablePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_IsSynchronizedInputPatternAvailablePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_OptimizeForVisualContentPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_IsObjectModelPatternAvailablePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_AnnotationAnnotationTypeIdPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_AnnotationAnnotationTypeNamePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_AnnotationAuthorPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_AnnotationDateTimePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_AnnotationTargetPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_IsAnnotationPatternAvailablePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_IsTextPattern2AvailablePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_StylesStyleIdPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_StylesStyleNamePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_StylesFillColorPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_StylesFillPatternStylePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_StylesShapePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_StylesFillPatternColorPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_StylesExtendedPropertiesPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_IsStylesPatternAvailablePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_IsSpreadsheetPatternAvailablePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_SpreadsheetItemFormulaPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_SpreadsheetItemAnnotationObjectsPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_SpreadsheetItemAnnotationTypesPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_IsSpreadsheetItemPatternAvailablePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_Transform2CanZoomPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_IsTransformPattern2AvailablePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_LiveSettingPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_IsTextChildPatternAvailablePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_IsDragPatternAvailablePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_DragIsGrabbedPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_DragDropEffectPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_DragDropEffectsPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_IsDropTargetPatternAvailablePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_DropTargetDropTargetEffectPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_DropTargetDropTargetEffectsPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_DragGrabbedItemsPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_Transform2ZoomLevelPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_Transform2ZoomMinimumPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_Transform2ZoomMaximumPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_FlowsFromPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_IsTextEditPatternAvailablePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_IsPeripheralPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_IsCustomNavigationPatternAvailablePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_PositionInSetPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_SizeOfSetPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_LevelPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_AnnotationTypesPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_AnnotationObjectsPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_LandmarkTypePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_LocalizedLandmarkTypePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_FullDescriptionPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_FillColorPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_OutlineColorPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_FillTypePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_VisualEffectsPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_OutlineThicknessPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_CenterPointPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_RotationPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_SizePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_IsSelectionPattern2AvailablePropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_Selection2FirstSelectedItemPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_Selection2LastSelectedItemPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_Selection2CurrentSelectedItemPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_Selection2ItemCountPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_HeadingLevelPropertyId"] = "UIA_RuntimeIdPropertyId";
  UIA_PropertyIds2["UIA_IsDialogPropertyId"] = "UIA_RuntimeIdPropertyId";
  return UIA_PropertyIds2;
})(UIA_PropertyIds || {});
var FrameMessenger = class {
  async send({ payload }) {
    return sendMessage({ type: "sendAndReceiveDataFromWindowsAgent", payload, timeout: 3e4 });
  }
  on(event, handler) {
    return sendMessageWithHandler({
      type: "sendAndReceiveDataFromWindowsAgent",
      payload: { methodName: "On", event },
      handler
    });
  }
};

// src/desktop/windows-agent/types/index.ts
var types_exports = {};
__export(types_exports, {
  HasChildrenCondition: () => HasChildrenCondition,
  Win32FinderAttribute: () => Win32FinderAttribute,
  Win32FinderBooleanOption: () => Win32FinderBooleanOption,
  Win32FinderNumberOption: () => Win32FinderNumberOption,
  Win32FinderStringOption: () => Win32FinderStringOption,
  WindowsAgentStatusCode: () => WindowsAgentStatusCode,
  WritebackOptionNumberOption: () => WritebackOptionNumberOption,
  WritebackOptionStringOption: () => WritebackOptionStringOption
});

// src/desktop/windows-agent/types/automationFinder.ts
var HasChildrenCondition = /* @__PURE__ */ ((HasChildrenCondition2) => {
  HasChildrenCondition2["ControlType"] = "ControlType";
  return HasChildrenCondition2;
})(HasChildrenCondition || {});

// src/desktop/windows-agent/types/win32Finder.ts
var Win32FinderAttribute = /* @__PURE__ */ ((Win32FinderAttribute2) => {
  Win32FinderAttribute2["isVisible"] = "isVisible";
  Win32FinderAttribute2["windowTitle"] = "windowTitle";
  Win32FinderAttribute2["className"] = "className";
  Win32FinderAttribute2["automationId"] = "automationId";
  Win32FinderAttribute2["isEnabled"] = "isEnabled";
  Win32FinderAttribute2["isUnicode"] = "isUnicode";
  Win32FinderAttribute2["contextHelpId"] = "contextHelpId";
  Win32FinderAttribute2["userData"] = "userdata";
  Win32FinderAttribute2["exstyle"] = "exstyle";
  Win32FinderAttribute2["style"] = "style";
  Win32FinderAttribute2["getCheckState"] = "getCheckState";
  Win32FinderAttribute2["controlType"] = "controlType";
  Win32FinderAttribute2["controlId"] = "controlId";
  Win32FinderAttribute2["isDialog"] = "isDialog";
  Win32FinderAttribute2["windowText"] = "windowText";
  Win32FinderAttribute2["isKeyboardFocusable"] = "isKeyboardFocusable";
  Win32FinderAttribute2["isActive"] = "isActive";
  Win32FinderAttribute2["texts"] = "texts";
  Win32FinderAttribute2["isChecked"] = "isChecked";
  Win32FinderAttribute2["url"] = "url";
  Win32FinderAttribute2["uiaText"] = "uiaText";
  return Win32FinderAttribute2;
})(Win32FinderAttribute || {});
var Win32FinderStringOption = /* @__PURE__ */ ((Win32FinderStringOption2) => {
  Win32FinderStringOption2["classNameRe"] = "classNameRe";
  Win32FinderStringOption2["autoIdRe"] = "autoIdRe";
  Win32FinderStringOption2["titleRe"] = "titleRe";
  Win32FinderStringOption2["searchId"] = "searchId";
  Win32FinderStringOption2["urlRe"] = "urlRe";
  Win32FinderStringOption2["uiaTextRe"] = "uiaTextRe";
  Win32FinderStringOption2["controlType"] = "controlType";
  Win32FinderStringOption2["windowTextRe"] = "windowTextRe";
  Win32FinderStringOption2["exstyle"] = "exstyle";
  Win32FinderStringOption2["style"] = "style";
  Win32FinderStringOption2["userdata"] = "userdata";
  Win32FinderStringOption2["contextHelpId"] = "contextHelpId";
  return Win32FinderStringOption2;
})(Win32FinderStringOption || {});
var Win32FinderNumberOption = /* @__PURE__ */ ((Win32FinderNumberOption2) => {
  Win32FinderNumberOption2["handle"] = "handle";
  Win32FinderNumberOption2["parentHandle"] = "parentHandle";
  Win32FinderNumberOption2["timeoutInSec"] = "timeoutInSec";
  Win32FinderNumberOption2["iterationLimit"] = "iterationLimit";
  Win32FinderNumberOption2["limit"] = "limit";
  Win32FinderNumberOption2["ctrlIndex"] = "ctrlIndex";
  Win32FinderNumberOption2["controlId"] = "controlId";
  return Win32FinderNumberOption2;
})(Win32FinderNumberOption || {});
var Win32FinderBooleanOption = /* @__PURE__ */ ((Win32FinderBooleanOption2) => {
  Win32FinderBooleanOption2["visibleOnly"] = "visibleOnly";
  Win32FinderBooleanOption2["isUnicode"] = "isUnicode";
  Win32FinderBooleanOption2["isEnabled"] = "isEnabled";
  Win32FinderBooleanOption2["isActive"] = "isActive";
  return Win32FinderBooleanOption2;
})(Win32FinderBooleanOption || {});
var WritebackOptionStringOption = /* @__PURE__ */ ((WritebackOptionStringOption2) => {
  WritebackOptionStringOption2["getter_function"] = "getter_function";
  WritebackOptionStringOption2["action"] = "action";
  WritebackOptionStringOption2["classNameRe"] = "classNameRe";
  return WritebackOptionStringOption2;
})(WritebackOptionStringOption || {});
var WritebackOptionNumberOption = /* @__PURE__ */ ((WritebackOptionNumberOption2) => {
  WritebackOptionNumberOption2["handle"] = "handle";
  WritebackOptionNumberOption2["limit"] = "limit";
  WritebackOptionNumberOption2["retryLimit"] = "retryLimit";
  WritebackOptionNumberOption2["sendMessageTimeout"] = "sendMessageTimeout";
  return WritebackOptionNumberOption2;
})(WritebackOptionNumberOption || {});
var WindowsAgentStatusCode = /* @__PURE__ */ ((WindowsAgentStatusCode2) => {
  WindowsAgentStatusCode2[WindowsAgentStatusCode2["Success"] = 200] = "Success";
  WindowsAgentStatusCode2[WindowsAgentStatusCode2["PartialSuccess"] = 207] = "PartialSuccess";
  WindowsAgentStatusCode2[WindowsAgentStatusCode2["BadInputs"] = 400] = "BadInputs";
  WindowsAgentStatusCode2[WindowsAgentStatusCode2["NotFound"] = 404] = "NotFound";
  WindowsAgentStatusCode2[WindowsAgentStatusCode2["FatalError"] = 500] = "FatalError";
  return WindowsAgentStatusCode2;
})(WindowsAgentStatusCode || {});

// src/desktop/windows-agent/index.ts
var WindowsAgent = class extends Hub {
  constructor() {
    const messenger = new FrameMessenger();
    super(messenger);
  }
  static isGetForegroundWindowDetailSsucessfull(windowProperties) {
    if (windowProperties?.processId === 0 || windowProperties?.processId === 4 || windowProperties?.processName === "Idle" || windowProperties?.processName === "System") {
      return false;
    } else {
      return true;
    }
  }
  get attacher() {
    return this.channel("attacher");
  }
  get queries() {
    return this.channel("queries");
  }
  get health() {
    return this.channel("health");
  }
  get automation() {
    return this.channel("uiaFinder");
  }
  get files() {
    return this.channel("files");
  }
  get win32() {
    return this.channel("win32Finder");
  }
};

// src/desktop/types.ts
var WriteBackType = /* @__PURE__ */ ((WriteBackType3) => {
  WriteBackType3["check"] = "check";
  WriteBackType3["click"] = "click";
  WriteBackType3["clickInput"] = "click_input";
  WriteBackType3["comObjectScript"] = "com_object_script";
  WriteBackType3["copyPaste"] = "copy_paste";
  WriteBackType3["keyboardSendKeys"] = "keyboard_send_keys";
  WriteBackType3["scroll"] = "scroll";
  WriteBackType3["select"] = "select";
  WriteBackType3["sendKeystrokes"] = "send_keystrokes";
  WriteBackType3["setEditText"] = "set_edit_text";
  WriteBackType3["setFocus"] = "set_focus";
  WriteBackType3["typeKeys"] = "type_keys";
  return WriteBackType3;
})(WriteBackType || {});
var SqlParameterType = /* @__PURE__ */ ((SqlParameterType2) => {
  SqlParameterType2["varchar"] = "varchar";
  SqlParameterType2["int"] = "int";
  return SqlParameterType2;
})(SqlParameterType || {});
var DllType = /* @__PURE__ */ ((DllType2) => {
  DllType2["flex_grid"] = "flex-grid";
  DllType2["anti_proxy"] = "anti-proxy";
  DllType2["fmt"] = "fmt";
  DllType2["vim_mfc"] = "vim-mfc";
  DllType2["sql_listener"] = "sql-listener";
  DllType2["sql_listener_next"] = "sql-listener-next";
  DllType2["wincrypt_detours"] = "wincrypt-detours";
  DllType2["wincrypt_detours_next"] = "wincrypt-detours-next";
  DllType2["nextgen_operations"] = "nextgen-operations";
  return DllType2;
})(DllType || {});
var DiagnosisSetType = /* @__PURE__ */ ((DiagnosisSetType2) => {
  DiagnosisSetType2["UPSERT"] = "upsert";
  DiagnosisSetType2["SET"] = "set";
  return DiagnosisSetType2;
})(DiagnosisSetType || {});
var NextGenOpsRequestType = /* @__PURE__ */ ((NextGenOpsRequestType2) => {
  NextGenOpsRequestType2["GET_ENCOUNTER_DIAGNOSIS"] = "get_encounter_diagnosis";
  NextGenOpsRequestType2["SET_ENCOUNTER_DIAGNOSIS"] = "set_encounter_diagnosis";
  NextGenOpsRequestType2["CHECK_ENCOUNTER_DRUG_INTERACTIONS"] = "check_encounter_drug_interactions";
  NextGenOpsRequestType2["SEARCH_DIAGNOSIS"] = "search_diagnosis";
  NextGenOpsRequestType2["GET_DB_CREDENTIALS"] = "get_db_connection_string";
  NextGenOpsRequestType2["CREATE_ENCOUNTER_DOCUMENT"] = "export_document";
  return NextGenOpsRequestType2;
})(NextGenOpsRequestType || {});
var FileManagerOperationType = /* @__PURE__ */ ((FileManagerOperationType2) => {
  FileManagerOperationType2["GET"] = "get";
  FileManagerOperationType2["REMOVE"] = "remove";
  return FileManagerOperationType2;
})(FileManagerOperationType || {});

// src/desktop/win32-deprecation-manager/index.ts
import { StorageKnownKey as StorageKnownKey2 } from "@getvim/vim-connect/src/infra/common/types";

// src/desktop/win32-deprecation-manager/events/common/checkWindowsAgentResponse.ts
function checkWindowsAgentResponse(result) {
  if (result.statusCode != 200 /* Success */) {
    if (result.errors.length > 0) {
      throw new Error(result.errors[0].context ? `${result.errors[0].context}: ${result.errors[0].message}` : `${result.errors[0].message}`);
    }
    throw new Error(`WindowsAgent: unknown failure: ${result.statusCode}`);
  }
}

// src/desktop/win32-deprecation-manager/events/closeWindow.ts
var TIMEOUT = 5e3;
var closeWindow = async (payload) => {
  const { window_handle } = payload;
  const handle = Number.parseInt(window_handle);
  const response = await windowsAgent.win32.closeWindow(handle, TIMEOUT);
  checkWindowsAgentResponse(response);
  return response.results[0];
};

// src/desktop/win32-deprecation-manager/events/common/getPid.ts
var getPid = async () => {
  return Number.parseInt(await getActiveWindow());
};

// src/desktop/win32-deprecation-manager/events/getDomElement.ts
var getDomElement = async ({
  window_handle,
  getter_function
}) => {
  if (!window_handle) {
    throw new Error(`getDomElement called without window handle`);
  }
  const windowHandle = `${window_handle}`;
  const pid = await getPid();
  const { payload, error } = await windowsAgent.win32.writeback(pid, {
    action: "run_com_script",
    handle: windowHandle,
    getter_function,
    retryLimit: "10"
  });
  if (error && error.message) {
    throw new Error(error.message);
  }
  return payload;
};

// src/desktop/win32-deprecation-manager/events/getForegroundWindow.ts
var getForegroundWindow = async () => {
  const response = await windowsAgent.queries.getForegroundWindowDetails();
  return {
    window_handle: response.handle?.value,
    process_id: response.processId,
    process_name: `${response.processName}.exe`,
    username: response.username,
    path: response.path
  };
};

// src/desktop/win32-deprecation-manager/events/getWindowsByCriteria.ts
var controlCriteriaToWindowFinderOptionMapping = {
  title: { key: "titleRe" /* titleRe */, transformer: (value) => `^${value}$` },
  title_re: { key: "titleRe" /* titleRe */ },
  auto_id: { key: "autoIdRe" /* autoIdRe */ },
  class_name: { key: "classNameRe" /* classNameRe */, transformer: (value) => `^${value}$` },
  class_name_re: { key: "classNameRe" /* classNameRe */ },
  parent: { key: "parentHandle" /* parentHandle */ },
  visible_only: { key: "visibleOnly" /* visibleOnly */ },
  control_id: { key: "controlId" /* controlId */ },
  search_id: { key: "searchId" /* searchId */ },
  handle: { key: "handle" /* handle */ },
  ctrl_index: { key: "ctrlIndex" /* ctrlIndex */ },
  url_re: { key: "urlRe" /* urlRe */ },
  uia_text_re: { key: "uiaTextRe" /* uiaTextRe */ },
  control_type: { key: "controlType" /* controlType */ },
  window_text_re: { key: "windowTextRe" /* windowTextRe */ },
  exstyle: { key: "exstyle" /* exstyle */ },
  style: { key: "style" /* style */ },
  userdata: { key: "userdata" /* userdata */ },
  context_help_id: { key: "contextHelpId" /* contextHelpId */ },
  is_unicode: { key: "isUnicode" /* isUnicode */ },
  is_enabled: { key: "isEnabled" /* isEnabled */ },
  is_active: { key: "isActive" /* isActive */ }
};
var getWindowsAgentOptions = async (controlCriteria, limit) => {
  const options = {};
  for (const [key, value] of Object.entries(controlCriteria)) {
    if (key === "top_level_only") {
      if (value === false && !controlCriteria.parent) {
        options["parentHandle" /* parentHandle */] = (await windowsAgent.win32.getDesktopWindow()).value;
      }
      continue;
    }
    if (key === "extraction_method") {
      continue;
    }
    const windowFinderOption = controlCriteriaToWindowFinderOptionMapping[key];
    if (!windowFinderOption) {
      throw new Error(`Window finder option ${key} is unimplemented`);
    }
    const { key: transformedKey, transformer } = windowFinderOption;
    const transformedValue = transformer ? transformer(value) : value;
    options[transformedKey] = transformedValue;
  }
  if (limit) {
    options["limit" /* limit */] = limit;
  }
  return options;
};
var getWindowsByCriteria = async (payload, limit) => {
  const pid = payload.parent_pid ?? await getPid();
  const options = await getWindowsAgentOptions(payload.control_criteria, limit);
  const windowsAgentResult = await windowsAgent.win32.getWindowsByCriteria(pid, options, [
    "windowText" /* windowText */
  ]);
  checkWindowsAgentResponse(windowsAgentResult);
  const formattedResults = windowsAgentResult.results.map((result) => {
    const handle = result.handle.value;
    const title = result.attributes.windowText.attributeValue;
    return {
      handle,
      title
    };
  });
  return formattedResults;
};

// src/desktop/win32-deprecation-manager/events/getWindowByCriteria.ts
var getWindowByCriteria = async (payload) => {
  const results = await getWindowsByCriteria(payload, 1);
  return { ...results[0] };
};

// src/desktop/win32-deprecation-manager/events/getWindowText.ts
var getWindowText = async ({ window_handle, parent_pid }) => {
  if (!window_handle) {
    throw new Error(`getWindowText called without window handle`);
  }
  const windowHandle = Number.parseInt(window_handle, 10);
  const pid = parent_pid ?? await getPid();
  const response = await windowsAgent.win32.getHandlesAttributes(pid, [windowHandle], ["windowText" /* windowText */]);
  checkWindowsAgentResponse(response);
  return response.results[0].attributes.windowText.attributeValue;
};

// src/desktop/win32-deprecation-manager/events/getWindowAttributes.ts
import { invert } from "lodash-es";
var win32ToWindowsAgentMapping = {
  is_visible: "isVisible" /* isVisible */,
  is_unicode: "isUnicode" /* isUnicode */,
  context_help_id: "contextHelpId" /* contextHelpId */,
  user_data: "userdata" /* userData */,
  exstyle: "exstyle" /* exstyle */,
  get_check_state: "getCheckState" /* getCheckState */,
  control_type: "controlType" /* controlType */,
  control_id: "controlId" /* controlId */,
  is_dialog: "isDialog" /* isDialog */,
  window_text: "windowText" /* windowText */,
  is_keyboard_focusable: "isKeyboardFocusable" /* isKeyboardFocusable */,
  class_name: "className" /* className */
};
function toWin32FinderAttribute(attributes) {
  const unsupportedAttributes = [];
  const response = [];
  for (const win32Attribute of attributes) {
    const windowsAgentAttribute = win32ToWindowsAgentMapping[win32Attribute];
    if (!windowsAgentAttribute) {
      unsupportedAttributes.push(win32Attribute);
    } else {
      response.push(windowsAgentAttribute);
    }
  }
  if (unsupportedAttributes.length) {
    throw new Error(`Unsupported attributes ${unsupportedAttributes}`);
  }
  return response;
}
var reverseMapping = invert(win32ToWindowsAgentMapping);
async function handleUIARequest(payload) {
  const response = {};
  for (const attribute of payload.attributes) {
    if (attribute === "window_text") {
      response.window_text = await windowsAgent.automation.getText(Number(payload.window_handle));
    } else {
      throw new Error(`Unsupported attribute ${String(attribute)}`);
    }
  }
  return response;
}
async function getWindowAttributes(payload) {
  if (!payload.window_handle) {
    throw new Error("Cant get attributes w/o handle");
  }
  if (payload.attributes.length === 0) {
    throw new Error("no attribute supplied to function");
  }
  if (payload.backend === "uia") {
    return await handleUIARequest(payload);
  }
  const attributes = toWin32FinderAttribute(payload.attributes);
  const pid = await getPid();
  const windowsAgentResponse = await windowsAgent.win32.getHandlesAttributes(pid, [payload.window_handle], attributes);
  checkWindowsAgentResponse(windowsAgentResponse);
  const windowsAgentWindowAttributes = windowsAgentResponse.results[0].attributes ?? {};
  const outputPayload = {};
  for (const [windowsAgentKey, win32Handle] of Object.entries(windowsAgentWindowAttributes)) {
    if (windowsAgentKey === "to-string") {
      continue;
    }
    const win32Key = reverseMapping[windowsAgentKey];
    if (!win32Key) {
      throw new Error(`unknown key from WindowsAgent - ${windowsAgentKey}`);
    }
    outputPayload[win32Key] = win32Handle.attributeValue;
  }
  return outputPayload;
}

// src/desktop/win32-deprecation-manager/events/isElementEnabled.ts
var getWindowHandle = async (controlCriteria, windowHandle) => {
  if (windowHandle) {
    return Number.parseInt(windowHandle);
  }
  const windows = await getWindowsByCriteria({ control_criteria: controlCriteria }, 1);
  if (windows.length === 0) {
    throw new Error(`Error getting isElementEnabled - Could not find window`);
  }
  return windows[0].handle;
};
var isElementEnabled = async ({
  window_handle,
  control_criteria
}) => {
  const windowHandle = await getWindowHandle(control_criteria, window_handle);
  const pid = await getPid();
  const response = await windowsAgent.win32.getHandlesAttributes(pid, [windowHandle], ["isEnabled" /* isEnabled */]);
  checkWindowsAgentResponse(response);
  const isEnabled = response.results[0].attributes["isEnabled" /* isEnabled */].attributeValue == "True";
  return isEnabled;
};

// src/desktop/win32-deprecation-manager/events/getWindowsByCriterias.ts
function extractAttributeFromExtractionMethod(control_criteria) {
  switch (control_criteria?.extraction_method) {
    case "texts":
      return "texts" /* texts */;
    case "is_checked":
      return "isChecked" /* isChecked */;
    default:
      return "windowText" /* windowText */;
  }
}
var getWindowsByCriterias = async (pid, payloads) => {
  const searches = await Promise.all(payloads.map(async (payload) => {
    const attribute = extractAttributeFromExtractionMethod(payload.control_criteria);
    return {
      options: await getWindowsAgentOptions(payload.control_criteria, 1),
      attributes: [attribute]
    };
  }));
  const resultArray = await windowsAgent.win32.getWindowsByCriterias(pid, searches);
  resultArray.forEach((result) => {
    checkWindowsAgentResponse(result);
  });
  return resultArray;
};

// src/desktop/win32-deprecation-manager/events/getControlsValue.ts
async function getControlsValue(payload) {
  if (!payload.window_handle)
    throw new Error("window_handle is required");
  const parent_pid = payload.parent_pid ?? await getPid();
  const mapped_inputs = [];
  for (const [control_id, control_criteria] of Object.entries(payload.control_searches)) {
    mapped_inputs.push({
      control_criteria: {
        ...control_criteria,
        parent: payload.window_handle,
        top_level_only: false,
        search_id: control_id
      }
    });
  }
  const results = await getWindowsByCriterias(parent_pid, mapped_inputs);
  if (results.some((result) => result.errors?.some((error) => error.context === "ValidateParentHandle"))) {
    throw new desktop_exports.MissingDesktopWindowError(payload.window_handle);
  }
  return results.reduce((acc, result) => {
    if (!result.searchId)
      return acc;
    return {
      ...acc,
      [result.searchId]: extractAttributesFromWin32Result(result)
    };
  }, {});
}
function extractAttributesFromWin32Result(result) {
  if (!result.results[0]) {
    return void 0;
  }
  const values = Array.from(Object.values(result.results[0].attributes));
  return values[0]?.attributeValue;
}

// src/desktop/win32-deprecation-manager/events/uiaHasChildren.ts
var controlCriteriaMapping = {
  control_type: "ControlType" /* ControlType */
};
var convertControlCriteria = (control_criteria) => {
  const response = {};
  for (const [key, value] of Object.entries(control_criteria)) {
    const windowsAgentCondition = controlCriteriaMapping[key];
    if (!windowsAgentCondition) {
      throw new Error(`Windows agent option ${key} is unimplemented`);
    }
    response[controlCriteriaMapping[key]] = value;
  }
  return response;
};
var uiaHasChildren = async (payload) => {
  if (payload.control_criteria === void 0) {
    throw new Error("control_criteria is required");
  }
  if (payload.window_handle === void 0) {
    throw new Error("window_handle is required");
  }
  const { handle } = await getWindowByCriteria({
    control_criteria: {
      parent: Number.parseInt(payload.window_handle, 10),
      ...payload.control_criteria
    }
  });
  if (!handle) {
    return false;
  }
  const conditions = convertControlCriteria(payload.child_condition);
  const result = await windowsAgent.automation.hasChildren(handle, conditions);
  return result;
};

// src/desktop/win32-deprecation-manager/events/writeback/index.ts
import { logger as LoggerImport2 } from "@getvim/vim-connect-logger";

// src/desktop/win32-deprecation-manager/events/writeback/click.ts
var DEFAULT_COORDS = [0, 0];
var click = async (handle, payload) => {
  const { coords: payloadCoords, coords_percentage, absolute, double } = payload;
  const isPrecentage = Boolean(coords_percentage);
  const coords = (isPrecentage ? coords_percentage : payloadCoords) ?? DEFAULT_COORDS;
  await windowsAgent.win32.click(handle, coords, isPrecentage, Boolean(absolute), Boolean(double));
};

// src/desktop/win32-deprecation-manager/events/writeback/scroll.ts
var scroll = async (handle, payload) => {
  await windowsAgent.win32.scroll(handle, payload.direction, payload.amount, payload.count ?? 0);
};

// src/desktop/win32-deprecation-manager/events/writeback/select.ts
var select = async (handle, payload) => {
  const { item } = payload;
  await (typeof item === "string" ? windowsAgent.win32.selectByText(handle, item) : windowsAgent.win32.selectByIndex(handle, item));
};

// src/desktop/win32-deprecation-manager/events/writeback/setFocus.ts
var setFocus = async (handle) => {
  await windowsAgent.win32.focusWindow(handle);
};

// src/desktop/win32-deprecation-manager/events/writeback/copyPaste.ts
var copyPaste = async (handle, payload) => {
  await windowsAgent.win32.copyPaste(handle, payload.text);
};

// src/desktop/win32-deprecation-manager/events/writeback/clickInput.ts
var DEFAULT_COORDS2 = [0, 0];
var clickInput = async (handle, payload) => {
  const { coords: payloadCoords, coords_percentage, absolute, double } = payload;
  const isPrecentage = Boolean(coords_percentage);
  const coords = (isPrecentage ? coords_percentage : payloadCoords) ?? DEFAULT_COORDS2;
  await windowsAgent.win32.clickInput(handle, coords, isPrecentage, Boolean(absolute), Boolean(double));
};

// src/desktop/win32-deprecation-manager/events/writeback/setEditText.ts
var setEditText = async (handle, payload) => {
  await windowsAgent.win32.setEditText(handle, payload.text);
};

// src/desktop/win32-deprecation-manager/events/writeback/sendKeystrokes.ts
var sendKeystrokes = async (handle, payload) => {
  await windowsAgent.win32.sendKeyStrokes(handle, payload.keystrokes);
};

// src/desktop/win32-deprecation-manager/events/writeback/index.ts
var handlers = {
  ["click" /* click */]: click,
  ["set_focus" /* setFocus */]: setFocus,
  ["scroll" /* scroll */]: scroll,
  ["set_edit_text" /* setEditText */]: setEditText,
  ["copy_paste" /* copyPaste */]: copyPaste,
  ["select" /* select */]: select,
  ["click_input" /* clickInput */]: clickInput,
  ["send_keystrokes" /* sendKeystrokes */]: sendKeystrokes
};
var writebackLogger = LoggerImport2.scope("win32Deprecation handle writeback");
var writebackAction = async (payload) => {
  const { type } = payload;
  const handler = handlers[type];
  if (!handler) {
    writebackLogger.info(`writeback ${type} connector not implemented`);
    return;
  }
  const windowHandle = payload["window_handle"] ?? payload.control_criteria?.handle ?? (await getWindowByCriteria({
    control_criteria: {
      ...payload.control_criteria,
      parent: payload.parent ? Number.parseInt(payload.parent) : void 0
    }
  })).handle;
  if (!windowHandle) {
    writebackLogger.info("no window handle found", { windowHandle, payload });
    return;
  }
  await handler(windowHandle, payload);
};

// src/desktop/win32-deprecation-manager/events/extractEcwEncryptionKey.ts
var extractEcwEncryptionKey = async ({
  fileName
}) => {
  const encryptionKeys = await windowsAgent.queries.extractEcwEncryptionKeyOld(fileName);
  return { encryptionKeys };
};

// src/desktop/win32-deprecation-manager/events/extractEcwEncryptionKeyV305.ts
var extractEcwEncryptionKeyV305 = async ({
  fileName
}) => {
  return await windowsAgent.queries.extractEcwEncryptionkeyV305(fileName);
};

// src/desktop/win32-deprecation-manager/events/decodeEcwPassword.ts
var decodeEcwPassword = async ({
  encryptionRequestBody,
  encryptionKey,
  timestamp
}) => {
  return await windowsAgent.queries.decodeEcwPasswordOld(encryptionRequestBody, encryptionKey, timestamp);
};

// src/desktop/win32-deprecation-manager/events/decodeEcwPasswordV305.ts
var decodeEcwPasswordV305 = async ({
  iv,
  key,
  data
}) => {
  return await windowsAgent.queries.deocdeEcwPasswordV305(iv, key, data);
};

// src/desktop/win32-deprecation-manager/events/index.ts
var windowsAgentEventHandlers = {
  get_controls_value: {
    handler: getControlsValue
  },
  get_windows_by_criteria: {
    handler: getWindowsByCriteria
  },
  get_window_by_criteria: {
    handler: getWindowByCriteria
  },
  get_foreground_window: {
    handler: getForegroundWindow
  },
  get_window_attributes: {
    handler: getWindowAttributes
  },
  is_element_enabled: {
    handler: isElementEnabled
  },
  close_window: {
    handler: closeWindow
  },
  get_dom_element: {
    handler: getDomElement
  },
  get_window_text: {
    handler: getWindowText
  },
  uia_has_children: {
    handler: uiaHasChildren
  },
  write_back_action: {
    handler: writebackAction
  },
  extract_ecw_encryption_key: {
    handler: extractEcwEncryptionKey
  },
  extract_ecw_encryption_key_v305: {
    handler: extractEcwEncryptionKeyV305
  },
  decode_ecw_password: {
    handler: decodeEcwPassword
  },
  decode_ecw_password_v305: {
    handler: decodeEcwPasswordV305
  }
};

// src/desktop/is-msi-version-greater-or-equal/index.ts
import { StorageKnownKey } from "@getvim/vim-connect/src/infra/common/types";
var lastThreeDigitVersion = [1, 1, 122];
var currentVersion;
function test_clear_current_version() {
  currentVersion = void 0;
}
async function getOrFetchMsiVersion() {
  if (!currentVersion) {
    currentVersion = await getCurrentVersion();
  }
  return currentVersion;
}
async function getAgentVersion() {
  const agentVersion = await getOrFetchMsiVersion();
  if (!agentVersion)
    return null;
  return agentVersion.join(".");
}
var isMSIVersionGreaterOrEqual = async (major, minor, patch) => {
  const versionToCompare = [major, minor, patch];
  const agentVersion = await getOrFetchMsiVersion();
  if (!agentVersion)
    return false;
  return isVersionLargerOrEqual(agentVersion, versionToCompare);
};
var versionSupportRobustInitializedConnection = async () => await isMSIVersionGreaterOrEqual(1, 2, 118);
var VersionExtractsEhrUrlFromFilePath = async () => await isMSIVersionGreaterOrEqual(1, 1, 142);
var VersionSupportsProcessFileInfo = async () => await isMSIVersionGreaterOrEqual(1, 1, 131);
var versionSupportsExtractEcwEncryptionKey = async () => await isMSIVersionGreaterOrEqual(1, 1, 149);
var versionSupportsInternetCookies = async () => await isMSIVersionGreaterOrEqual(1, 1, 152);
var versionSupportsSetTrayStates = async () => await isMSIVersionGreaterOrEqual(1, 1, 153);
var versionSupportsTogglingIncognito = async () => await isMSIVersionGreaterOrEqual(1, 1, 154);
var versionSupportsGetOrganizationByKey = async () => await isMSIVersionGreaterOrEqual(1, 1, 157);
var versionSupportsDebugDllInjection = async () => await isMSIVersionGreaterOrEqual(1, 1, 173);
var versionSupportsElectronDllInjection = async () => await isMSIVersionGreaterOrEqual(1, 1, 175);
var versionSupportsDllInjectionIdentifier = async () => await isMSIVersionGreaterOrEqual(2, 70, 1);
var textVersionSupportsStatelessNodeFetch = "1.2.0";
var versionSupportsStatelessNodeFetch = async () => await isMSIVersionGreaterOrEqual(1, 2, 0);
var versionSupportsMultiProcess = async () => await isMSIVersionGreaterOrEqual(1, 2, 0);
var versionSupportsGetComputerIdle = async () => await isMSIVersionGreaterOrEqual(1, 2, 11);
var versionSupportsSqlQueriesListener = async () => await isMSIVersionGreaterOrEqual(1, 2, 31);
var versionSupportsNewAntiProxyDll = async () => await isMSIVersionGreaterOrEqual(1, 2, 37);
var versionSupportWindowWatcherWithInstanceId = async () => await isMSIVersionGreaterOrEqual(1, 2, 50);
var versionSupportsStatusBarNextgen = async () => await isMSIVersionGreaterOrEqual(1, 2, 55);
var versionSupportsWincryptDetours = async () => await isMSIVersionGreaterOrEqual(1, 2, 60);
var versionSupportsEcwEncryptionV2 = async () => await isMSIVersionGreaterOrEqual(1, 2, 67);
var versionSupportsInjectDllService = async () => await isMSIVersionGreaterOrEqual(1, 2, 152);
var versionSupportsIntegrationToolManager = async () => await isMSIVersionGreaterOrEqual(1, 2, 184);
var versionSupportsFullIntegrationToolManager = async () => await isMSIVersionGreaterOrEqual(1, 2, 225);
var versionSupportsWin32IntegrationToolManager = async () => await isMSIVersionGreaterOrEqual(1, 2, 229);
var versionSupportsNewNextgenLoginDetection = async () => await isMSIVersionGreaterOrEqual(1, 2, 241);
var versionSupportUseProcessExistsFromElectron = async () => await isMSIVersionGreaterOrEqual(1, 2, 243);
var versionSupportsNewNextgenDll = async () => await isMSIVersionGreaterOrEqual(1, 2, 271);
var versionSupportsNewWinCryptNextgenDll = async () => await isMSIVersionGreaterOrEqual(1, 38, 0);
var versionSupportsWindowsAgentHealthCheck = async () => await isMSIVersionGreaterOrEqual(1, 2, 199);
var versionSupportsGetImageVersionByName = async () => await isMSIVersionGreaterOrEqual(1, 2, 131);
var versionSupportsEcwPluginModification = async () => await isMSIVersionGreaterOrEqual(1, 2, 175);
var versionSupportsRemoteBrowserWindows = async () => await isMSIVersionGreaterOrEqual(1, 2, 182);
var versionSupportsNewGetDomElementFunction = async () => await isMSIVersionGreaterOrEqual(1, 2, 209);
var versionSupportsForcedIntegrationToolKill = async () => await isMSIVersionGreaterOrEqual(1, 2, 264);
var versionSupportsIsElementEnabled = async () => await isMSIVersionGreaterOrEqual(1, 2, 274);
var versionSupportsFixedGetDomElement = async () => await isMSIVersionGreaterOrEqual(1, 2, 276);
var versionSupportsRecreateWin32Ipcs = async () => await isMSIVersionGreaterOrEqual(1, 2, 283);
var versionSupportsStopOnCriticalFail = async () => await isMSIVersionGreaterOrEqual(1, 2, 283);
var versionSupportsWindowsAgentWin32 = async () => await isMSIVersionGreaterOrEqual(1, 90, 0);
var versionSupportsWindowsAgentWin32TypedResponses = async () => await isMSIVersionGreaterOrEqual(1, 95, 0);
var versionSupportsExtendEnvVars = async () => await isMSIVersionGreaterOrEqual(1, 2, 304);
var versionSupportsVimOs = async () => await isMSIVersionGreaterOrEqual(1, 3, 1);
var versionSupportsDeletingEcwPluginProducts = async () => await isMSIVersionGreaterOrEqual(1, 60, 0);
var versionSupportsEcwPluginInjection = async () => await isMSIVersionGreaterOrEqual(1, 113, 0);
var versionSupportsBase64NodeFetch = async () => await isMSIVersionGreaterOrEqual(1, 65, 0);
var versionSupportsWindowsAgentWriteback = async () => await isMSIVersionGreaterOrEqual(1, 117, 0);
var versionSupportsGetTaskListByProcessList = async () => await isMSIVersionGreaterOrEqual(1, 142, 1);
var versionSupposedWindowsAgentProcessEnum = async () => await isMSIVersionGreaterOrEqual(1, 149, 0);
var versionSupportsV2Adapter = async () => await isMSIVersionGreaterOrEqual(1, 180, 0);
var versionSupportsFlexGridDll = async () => await isMSIVersionGreaterOrEqual(2, 17, 0);
var versionSupportsNextgenEncounter = async () => await isMSIVersionGreaterOrEqual(2, 70, 0);
var versionSupportsNextgenSearchAndDrugInteractions = async () => await isMSIVersionGreaterOrEqual(2, 71, 0);
var versionSupportsNextgenPrintEncounter = async () => await isMSIVersionGreaterOrEqual(2, 74, 0);
function isVersionLargerOrEqual(versionA, versionB) {
  if (versionB.length > versionA.length)
    throw new Error("Invalid input, versionB is longer than versionA");
  for (const [i, element] of versionB.entries()) {
    if (versionA[i] !== element)
      return versionA[i] > element;
  }
  return true;
}
async function getCurrentVersion() {
  const msiVersion = await Promise.race([
    getEnvironmentVariable({ key: StorageKnownKey.MSI_VERSION }),
    new Promise((resolve) => setTimeout(() => resolve(void 0), 1e4))
  ]);
  if (!msiVersion) {
    return void 0;
  }
  let detectedVersion = msiVersion.split(".").map((x) => Number.parseInt(x, 10));
  const isFourDigitVersion = detectedVersion.length === 4;
  if (!isFourDigitVersion && isVersionLargerOrEqual(detectedVersion, lastThreeDigitVersion)) {
    detectedVersion = lastThreeDigitVersion;
  }
  return detectedVersion;
}

// src/desktop/win32-deprecation-manager/index.ts
import { logger as LoggerImport3 } from "@getvim/vim-connect-logger";
var DEPRECATION_MINIMAL_VERSION = [2, 45, 0];
var Win32DeprecationManagerInstance = class {
  win32DetectorRunning = true;
  missingInformation = false;
  missingInfoLogged = false;
  constructor(win32DetectorRunning) {
    const logger4 = LoggerImport3.scope("Win32DeprecationReporter");
    if (typeof win32DetectorRunning === "boolean") {
      this.win32DetectorRunning = win32DetectorRunning;
      logger4.debug("Win32DeprecationManager: win32-detector is *explicitly* set", {
        win32DetectorRunning,
        url: window?.location?.href
      });
      return;
    }
    if (!window || !window.location) {
      logger4.error("Win32DeprecationManager: Window or location is not accessible");
      return;
    }
    const url = new URL(window.location.href);
    if (!url.searchParams.has("win32-detector")) {
      logger4.error("Win32DeprecationManager: useWin32Detector parameter is missing in URL: ", {
        url: window.location.href
      });
      this.missingInformation = true;
      return;
    }
    this.win32DetectorRunning = url.searchParams.get("win32-detector") === "true";
    logger4.debug(`Win32DeprecationManager: win32-detector is set to ${this.win32DetectorRunning}`);
  }
  debugModeCache;
  async isDebugMode() {
    if (this.debugModeCache === void 0) {
      const { win32Deprecation_debugMode: value } = await storageGet({
        key: StorageKnownKey2.WIN32DEPRECATION_DEBUG
      });
      this.debugModeCache = Boolean(value);
    }
    return this.debugModeCache;
  }
  async shouldLogForNotUseResponse(reason) {
    if (reason === "HANDLER_DOESNT_EXIST" /* HANDLER_DOESNT_EXIST */) {
      return true;
    }
    return await this.isDebugMode();
  }
  async getShouldNotUseResponse(reason) {
    return {
      shouldUse: false,
      reason,
      shouldLog: await this.shouldLogForNotUseResponse(reason)
    };
  }
  async getHandler(payload) {
    if (!await isMSIVersionGreaterOrEqual(...DEPRECATION_MINIMAL_VERSION)) {
      return await this.getShouldNotUseResponse("MSI_VERSION_OLD" /* MSI_VERSION_OLD */);
    }
    const handlerConfig = windowsAgentEventHandlers[payload.event];
    if (!handlerConfig) {
      return await this.getShouldNotUseResponse("HANDLER_DOESNT_EXIST" /* HANDLER_DOESNT_EXIST */);
    }
    return {
      shouldUse: true,
      handler: handlerConfig.handler,
      shouldUseInsteadOfWin32: true
    };
  }
  isWin32DetectorRunning() {
    return this.win32DetectorRunning;
  }
  validateInstance(event) {
    if (this.missingInformation && !this.missingInfoLogged) {
      const logger4 = LoggerImport3.scope("Win32DeprecationReporter");
      logger4.error("Win32DeprecationManager: Trying to use instance with missing information in URL", event);
      this.missingInfoLogged = true;
    }
  }
};
var _Win32DeprecationManager = class {
  static getInstance() {
    if (!_Win32DeprecationManager.instance) {
      _Win32DeprecationManager.instance = new Win32DeprecationManagerInstance();
    }
    return _Win32DeprecationManager.instance;
  }
  static initialize(win32DetectorRunning) {
    if (_Win32DeprecationManager.instance) {
      throw new Error("Win32DeprecationManager is already initialized");
    }
    _Win32DeprecationManager.instance = new Win32DeprecationManagerInstance(win32DetectorRunning);
  }
};
var Win32DeprecationManager = _Win32DeprecationManager;
__publicField(Win32DeprecationManager, "instance");

// src/desktop/win32-deprecation-manager/reporter.ts
import { logger as LoggerImport4 } from "@getvim/vim-connect-logger";
var FLUSH_REPORT_INTERVAL_IN_MS = 1e3 * 60 * 10;
var Win32DeprecationReporterInstance = class {
  reportedEvents = /* @__PURE__ */ new Set();
  flushReportsInterval;
  logger = LoggerImport4.scope("Win32DeprecationReporter");
  constructor() {
    this.flushReportsInterval = setInterval(this.flushReportedPayloads.bind(this), FLUSH_REPORT_INTERVAL_IN_MS);
  }
  stopFlushReportsInterval() {
    clearInterval(this.flushReportsInterval);
  }
  flushReportedPayloads() {
    this.reportedEvents = /* @__PURE__ */ new Set();
  }
  eventSentAlready(payload) {
    const payloadString = JSON.stringify(payload);
    if (this.reportedEvents.has(payloadString)) {
      return true;
    }
    this.reportedEvents.add(payloadString);
    return false;
  }
  reportShouldNotUseHandler({ event, reason }) {
    if (this.eventSentAlready(event)) {
      return;
    }
    if (reason === "HANDLER_DOESNT_EXIST" /* HANDLER_DOESNT_EXIST */) {
      this.logger.info("WindowsAgent handler doesnt exist - this shouldnt happen", {
        reason,
        event
      });
      return;
    }
    this.logger.debug("Should not use Windows agent.", {
      reason,
      event
    });
  }
  reportErrorGettingHandler({ error, event }) {
    if (this.eventSentAlready(event)) {
      return;
    }
    this.logger.warning("Error getting windows agent handler", {
      error,
      event
    });
  }
  reportErrorRunningHandler({ error, event }) {
    if (this.eventSentAlready(event)) {
      return;
    }
    this.logger.warning("Error running windows agent handler", {
      error,
      event
    });
  }
  reportWindowsAgentWin32Compare({
    event,
    win32Response,
    win32DurationInMS,
    windowsAgentResponse,
    windowsAgentDurationInMS
  }) {
    if (this.eventSentAlready(event)) {
      return;
    }
    this.logger.info(`Comparing Windows-agent and win32 results`, {
      event,
      windowsAgentResponse,
      win32Response,
      windowsAgentDurationInMS,
      win32DurationInMS
    });
  }
};
var Win32DeprecationReporter = class {
  static getInstance() {
    if (!this.instance) {
      this.instance = new Win32DeprecationReporterInstance();
    }
    return this.instance;
  }
};
__publicField(Win32DeprecationReporter, "instance");

// src/desktop/win32-deprecation-manager/win32Bypass.ts
import { logger as LoggerImport5 } from "@getvim/vim-connect-logger";
var ASYNC_WIN32_EVENTS = /* @__PURE__ */ new Set([
  "close_window",
  "write_back_action",
  "ehr_process_name",
  "listen_to_window"
]);
async function runWin32Function({
  event,
  timeout
}) {
  const deprecationManager = Win32DeprecationManager.getInstance();
  if (!deprecationManager.isWin32DetectorRunning()) {
    const logger4 = LoggerImport5.scope("Win32DeprecationReporter");
    logger4.warning(`Trying to use win32-detector for ${event.event} when it is not running`);
    throw new Error(`Trying to use win32-detector for ${event.event}, but it is not running`);
  }
  if (ASYNC_WIN32_EVENTS.has(event.event)) {
    return sendAsyncMessage({
      type: "sendDataToWin32",
      payload: event
    });
  }
  return await sendMessage({
    type: "sendAndReceiveDataFromWin32",
    payload: event || {},
    timeout
  });
}
function formatWindowsAgentResponse(windowsAgentResult, event) {
  return {
    event: event.event,
    payload: windowsAgentResult
  };
}
async function win32Bypass({
  event,
  timeout
}) {
  let deprecationManagerResponse;
  const deprecationManager = Win32DeprecationManager.getInstance();
  const reporterInstance = Win32DeprecationReporter.getInstance();
  deprecationManager.validateInstance(event);
  try {
    deprecationManagerResponse = await deprecationManager.getHandler(event);
  } catch (error) {
    reporterInstance.reportErrorGettingHandler({
      error,
      event
    });
    return await runWin32Function({ event, timeout });
  }
  if (!deprecationManagerResponse.shouldUse) {
    if (deprecationManagerResponse.shouldLog) {
      reporterInstance.reportShouldNotUseHandler({
        event,
        reason: deprecationManagerResponse.reason
      });
    }
    return await runWin32Function({ event, timeout });
  }
  if (deprecationManagerResponse.shouldUseInsteadOfWin32) {
    try {
      const windowsAgentResponse = await deprecationManagerResponse.handler(event.payload);
      return formatWindowsAgentResponse(windowsAgentResponse, event);
    } catch (error) {
      if (!deprecationManager.isWin32DetectorRunning()) {
        throw error;
      }
      try {
        const ret = await runWin32Function({ event, timeout });
        reporterInstance.reportErrorRunningHandler({
          event,
          error
        });
        return ret;
      } catch {
        throw error;
      }
    }
  }
  const win32StartTime = Date.now();
  const win32Response = await runWin32Function({ event, timeout });
  const win32DurationInMS = Date.now() - win32StartTime;
  const baseReportParams = { event, win32Response, win32DurationInMS };
  const windowsAgentStartTime = Date.now();
  deprecationManagerResponse.handler(event.payload).then((windowsAgentResponse) => {
    const formattedResponse = formatWindowsAgentResponse(windowsAgentResponse, event);
    const windowsAgentDurationInMS = Date.now() - windowsAgentStartTime;
    reporterInstance.reportWindowsAgentWin32Compare({
      ...baseReportParams,
      windowsAgentResponse: formattedResponse,
      windowsAgentDurationInMS
    });
  }).catch((error) => {
    reporterInstance.reportErrorRunningHandler({
      ...baseReportParams,
      error
    });
  });
  return win32Response;
}

// src/common/constants.ts
var WINDOW_NOT_FOUND_ERROR_TEXT = "Window not found";
var PROCESS_NOT_FOUND_ERROR_TEXT = "Process not found";

// src/desktop/fetch-session.ts
import { retry } from "@vim/promise";
import { logger as LoggerImport6 } from "@getvim/vim-connect-logger";
async function fetchSessionGet(payload) {
  const MAX_RETRIES = 5;
  const logger4 = LoggerImport6.scope(`infra/extension-connector/connector/desktop/fetch-session-get`);
  return retry(async (attemptNumber) => {
    if (attemptNumber > 1) {
      if (attemptNumber > MAX_RETRIES / 2) {
        logger4.warning(`Retry number ${attemptNumber} to access API`);
      } else {
        logger4.info(`Retry number ${attemptNumber} to access API`);
      }
    }
    return sendMessage({
      type: "fetchSessionGet",
      payload
    });
  }, {
    retries: MAX_RETRIES,
    minTimeout: 200,
    factor: 1,
    stopRetryPredicate: (error) => typeof error === "string" && error.includes(`Cannot read property 'get' of undefined`)
  });
}
async function clearFetchSessions() {
  return sendMessage({
    type: "clearFetchSessions"
  });
}
async function clearSessionCookie(payload) {
  return sendMessage({
    type: "clearSessionCookie",
    payload
  });
}
async function clearSessionCookies(payload) {
  return sendMessage({
    type: "clearSessionCookies",
    payload
  });
}
async function addSessionCookie(payload) {
  return sendMessage({
    type: "addSessionCookie",
    payload
  });
}
async function initSession(payload) {
  return sendMessage({
    type: "initSession",
    payload
  });
}

// src/desktop/sql.ts
var eventMap = {
  get: "sqlQuery",
  disconnect: "sqlDisconnect",
  initialize: "sqlInitialize",
  restartPool: "sqlRestartPool"
};
async function sendAndReceiveDataFromSql(payload) {
  const { event, payload: parsedPayload } = payload;
  const response = await sendMessage({
    type: eventMap[event],
    payload: parsedPayload
  });
  return response;
}

// src/desktop/fileSystemUtils.ts
function readHostFile(payload) {
  return sendMessage({
    type: "readHostFile",
    payload
  });
}

// src/desktop/connectors.ts
var defineMessage = (type) => (payload, timeout) => sendMessage({
  type,
  payload,
  timeout
});
async function getEhrVersion() {
  const logger4 = LoggerImport7.scope(`infra/extension-connector/connector/desktop/getEhrVersion`);
  try {
    return await sendMessage({
      type: "getEhrVersion",
      timeout: 7500
    });
  } catch (error) {
    if (error instanceof SyncExtensionConnectorTimeoutError2) {
      logger4.warning("getEhrVersion returned timeout, probably version mismatch", {
        error: error?.message
      });
    } else {
      logger4.warning("getEhrVersion returned unknown error", { error: error?.message });
    }
    return void 0;
  }
}
async function getLoginState() {
  return await sendMessage({
    type: "getLoginState",
    timeout: 2e3
  });
}
async function getDMRFlags() {
  const logger4 = LoggerImport7.scope(`infra/extension-connector/connector/desktop/getDMRFlags`);
  try {
    return await sendMessage({
      type: "getDMRFlags",
      timeout: 2e3
    });
  } catch (error) {
    if (error instanceof SyncExtensionConnectorTimeoutError2) {
      logger4.warning("getDMRFlags returned timeout", { error });
    } else {
      logger4.warning("getDMRFlags returned unknown error", { error });
    }
    return void 0;
  }
}
async function getEhrProcessPath() {
  const logger4 = LoggerImport7.scope(`infra/extension-connector/connector/desktop/getEhrProcessPath`);
  try {
    return await sendMessage({
      type: "getEhrProcessPath",
      timeout: 2e3
    });
  } catch (error) {
    if (error instanceof SyncExtensionConnectorTimeoutError2) {
      logger4.warning("getEhrProcessPath returned timeout, probably version mismatch", { error });
    } else {
      logger4.warning("getEhrProcessPath returned unknown error", { error });
    }
    return void 0;
  }
}
async function listenToDataFromEhr({ handler }) {
  const listenerId = await sendMessageWithHandler({
    type: "listenToDataFromEhr",
    handler
  });
  return listenerId ? { remove: () => removeListener({ listenerId }), listenerId } : false;
}
function sendProcessSettings(payload) {
  sendAsyncMessage({
    type: "sendProcessSettings",
    payload
  });
}
function sendCloseAll() {
  setTimeout(() => sendAsyncMessage({
    type: "sendCloseAll"
  }), 500);
}
function sendDataToProxy(payload) {
  sendAsyncMessage({
    type: "sendDataToProxy",
    payload
  });
}
var ProcessNotFoundError = class extends Error {
  constructor(message) {
    if (message) {
      super(message);
    } else
      super(PROCESS_NOT_FOUND_ERROR_TEXT);
  }
};
var WindowNotFoundError = class extends ProcessNotFoundError {
  constructor(message) {
    if (message) {
      super(message);
    } else
      super(WINDOW_NOT_FOUND_ERROR_TEXT);
  }
};
var MissingDesktopWindowError = class extends WindowNotFoundError {
  constructor(handle, message) {
    super(message);
    this.handle = handle;
  }
};
var wrappedErrorIfIsOfTypeWinNotFound = (err) => {
  if (typeof err === "string") {
    if (err.startsWith("Process with PID=") && err.endsWith(" not found!") || err.includes("pywinauto.application.ProcessNotFoundError")) {
      throw new ProcessNotFoundError();
    } else if (err.includes("Invalid handle") || err.includes("is not a valid window handle") || err.includes("is not a vaild window handle") || err.includes("An event was unable to invoke any of the subscribers") || err.includes("Couldn't find a valid process for given window handle")) {
      throw new WindowNotFoundError();
    }
  }
  throw err;
};
async function sendAndReceiveDataFromWin32(payload, timeout = LISTEN_ONCE_TTL) {
  try {
    const response = await win32Bypass({
      event: payload,
      timeout
    });
    return response;
  } catch (error) {
    return wrappedErrorIfIsOfTypeWinNotFound(error);
  }
}
async function sendAndReceiveDataFromSqlTunnel(payload) {
  return await sendMessage({
    type: "sendAndReceiveDataFromSqlTunnel",
    payload
  });
}
function addUrlToListen(payload) {
  sendDataToProxy({
    event: "addUrlToListen",
    payload
  });
}
function sendEhrProcessNameToWin32(ehrProcessName) {
  sendAndReceiveDataFromWin32({
    event: "ehr_process_name",
    payload: ehrProcessName
  }).then(() => {
  }).catch(() => {
  });
}
function addWindowToListen(payload) {
  sendAndReceiveDataFromWin32({
    event: "listen_to_window",
    payload
  }).then(() => {
  }).catch(() => {
  });
}
function addWindowsToListenV2(payload) {
  sendAsyncMessage({
    type: "listenToWindows",
    payload
  });
}
async function healthCheckWin32(timeout = LISTEN_ONCE_TTL) {
  const healthCheck = { payload: {} };
  return await sendMessage({
    type: "sendAndReceiveDataFromWin32",
    payload: {
      event: "health-check",
      payload: healthCheck
    },
    timeout
  });
}
async function recreateWin32Pipe(timeout) {
  const payload = { timeout };
  await sendMessage({
    type: "recreateWin32Pipe",
    payload
  });
}
async function triggerInjectDllToProcess(payload) {
  return await sendAndReceiveDataFromWin32({
    event: "inject_dll_to_process",
    payload
  });
}
function setRuntimeCookie(payload) {
  sendAsyncMessage({
    type: "setRuntimeCookie",
    payload
  });
}
function addAccessControlAllowOrigin(payload) {
  return sendMessage({
    type: "addAccessControlAllowOrigin",
    payload
  });
}
async function uiaHasChildren2(payload) {
  return await sendAndReceiveDataFromWin32({
    event: "uia_has_children",
    payload
  });
}
async function win32IsElementEnabled(payload) {
  return await sendAndReceiveDataFromWin32({
    event: "is_element_enabled",
    payload
  });
}
async function win32GetControlsValues(payload) {
  return await sendAndReceiveDataFromWin32({
    event: "get_controls_value",
    payload
  });
}
async function win32GetCursorHighlightedWindow(payload = {}) {
  return await sendAndReceiveDataFromWin32({
    event: "get_cursor_highlighted_window",
    payload
  });
}
async function win32GetForegroundWindow() {
  return await sendAndReceiveDataFromWin32({
    event: "get_foreground_window",
    payload: {}
  });
}
var windowsAgent = new WindowsAgent();
async function win32GetWindowAttributes(payload) {
  return await sendAndReceiveDataFromWin32({
    event: "get_window_attributes",
    payload
  });
}
async function sqlTunnelInitialize(payload) {
  return await sendAndReceiveDataFromSqlTunnel({
    event: "initialize",
    payload
  });
}
async function sqlTunnelDisconnect() {
  return await sendAndReceiveDataFromSqlTunnel({
    event: "disconnect",
    payload: {}
  });
}
async function win32GetProcessAttributes(payload) {
  return await sendAndReceiveDataFromWin32({
    event: "get_process_attributes",
    payload
  });
}
async function win32GetChildProcesses(payload) {
  return await sendAndReceiveDataFromWin32({
    event: "get_child_processes",
    payload
  });
}
async function win32GetWindowText(payload) {
  return await sendAndReceiveDataFromWin32({
    event: "get_window_text",
    payload
  });
}
function win32CloseWindow(payload) {
  sendAndReceiveDataFromWin32({
    event: "close_window",
    payload
  }).then(() => {
  }).catch(() => {
  });
}
async function win32WaitForWindowV2(payload, retryOptions, ehrInstanceId) {
  return await retry2(async () => {
    const response = await sendAndReceiveDataFromWin32({
      event: "get_window_by_criteria",
      payload,
      ...ehrInstanceId ? { ehrInstanceId } : {}
    });
    if (!response.payload.handle)
      throw new WindowNotFoundError("window not found!");
    return response.payload;
  }, { retries: 5, minTimeout: 200, ...retryOptions }).catch(WindowNotFoundError, () => null);
}
async function windowsAgentWaitForWindow(pid, classNameRegex, titleRegex, automationId, retries, minTimeout) {
  return await retry2(async () => {
    const response = await windowsAgent.automation.findTopMostWindows(pid, classNameRegex, titleRegex, automationId);
    if (!response)
      throw new WindowNotFoundError("window not found!");
    return response;
  }, { retries, minTimeout }).catch(WindowNotFoundError, () => null);
}
async function win32GetWindowByCriteria(payload, ehrInstanceId) {
  return await sendAndReceiveDataFromWin32({
    event: "get_window_by_criteria",
    payload,
    ...ehrInstanceId ? { ehrInstanceId } : {}
  });
}
async function win32GetProcessExists(payload) {
  return await sendAndReceiveDataFromWin32({
    event: "get_process_exists",
    payload
  });
}
async function doesProcessExists(pid) {
  try {
    return await sendMessage({
      type: "isProcessAlive",
      payload: { pid }
    });
  } catch (error) {
    return wrappedErrorIfIsOfTypeWinNotFound(error);
  }
}
async function win32GetWindows(payload, ehrInstanceId) {
  const response = await sendAndReceiveDataFromWin32({
    event: "get_windows_by_criteria",
    payload,
    ...ehrInstanceId ? { ehrInstanceId } : {}
  });
  if (!response.payload.length)
    throw new WindowNotFoundError("window not found!");
  return response.payload;
}
async function win32waitForWindows(payload, retryOptions, ehrInstanceId) {
  return await retry2(async () => {
    const response = await sendAndReceiveDataFromWin32({
      event: "get_windows_by_criteria",
      payload,
      ...ehrInstanceId ? { ehrInstanceId } : {}
    });
    if (!response.payload.length)
      throw new WindowNotFoundError("window not found!");
    return response.payload;
  }, {
    retries: 4,
    minTimeout: 200,
    ...retryOptions
  }).catch(WindowNotFoundError, () => []);
}
async function windowsAgentwin32waitForWindows(payload, retryOptions) {
  return await retry2(async () => {
    const pid = await getActiveWindow();
    const rawResponse = await windowsAgent.win32.getWindowsByCriteria(Number.parseInt(pid, 10), {
      ["titleRe" /* titleRe */]: payload.control_criteria.title_re
    }, ["windowTitle" /* windowTitle */]);
    if (rawResponse.errors.length !== 0) {
      throw new Error(rawResponse.errors[0].message);
    }
    const formatted = rawResponse.results.map((result) => {
      const handle = result.handle.value;
      const title = result.attributes.windowTitle.attributeValue;
      return {
        handle,
        title
      };
    });
    return formatted;
  }, {
    retries: 4,
    minTimeout: 200,
    ...retryOptions
  }).catch(WindowNotFoundError, () => []);
}
async function listenToDataFromAntiProxy({
  pid,
  handler
}) {
  const listenerId = await sendMessageWithHandler({
    type: "listenToDataFromAntiProxy",
    payload: { pid },
    handler
  });
  if (listenerId) {
    const pipeState = {
      remove: () => removeListener({ listenerId }),
      pid
    };
    return pipeState;
  }
  return false;
}
async function listenToDataFromGlobalShortcut({
  shortcut,
  handler
}) {
  await sendMessageWithHandler({
    type: "listenToDataFromGlobalShortcut",
    payload: { shortcut },
    handler
  });
}
function removeListenerToDataFromGlobalShortcut({ shortcut }) {
  sendAsyncMessage({
    type: "removeListenerToDataFromGlobalShortcut",
    payload: { shortcut }
  });
}
async function listenToDataFromSqlListener({
  pid,
  handler
}) {
  const listenerId = await sendMessageWithHandler({
    type: "listenToDataFromSqlListener",
    payload: { pid },
    handler
  });
  if (listenerId) {
    const pipeState = {
      pid
    };
    return pipeState;
  }
  return false;
}
async function listenToDataFromIpc({
  channel,
  listenerIdOverride,
  encoding,
  rawBuffer,
  useDuplex,
  handler
}) {
  const listenerId = listenerIdOverride ?? uuid2();
  await sendMessageWithHandler({
    type: "listenToDataFromIpc",
    payload: { channel, listenerId, encoding, rawBuffer, useDuplex },
    handler
  });
  return listenerId;
}
function win32WriteBackAction(payload) {
  if (!payload.backend) {
    payload.backend = "win32";
  }
  sendAndReceiveDataFromWin32({
    event: "write_back_action",
    payload
  }).then(() => {
  }).catch(() => {
  });
}
function win32WriteBackActionSync(payload) {
  if (!payload.backend) {
    payload.backend = "win32";
  }
  return sendAndReceiveDataFromWin32({
    event: "write_back_action",
    payload
  });
}
async function sqlTunnelGet(payload) {
  return await sendAndReceiveDataFromSqlTunnel({
    event: "get",
    payload
  });
}
async function sqlTunnelGetOne(payload) {
  const { parameters } = payload;
  const logger4 = LoggerImport7.scope(`infra/extension-connector/connector/desktop/sqlTunnelGetOne`);
  return await sqlTunnelGet(payload).then(({ result }) => {
    if (result.length > 1) {
      logger4.warning("got more than one response from DB to sqlTunnelGetOne query", {
        parameters,
        result
      });
    }
    return result[0];
  });
}
async function sqlTunnelEnforceGetOne(payload) {
  const { parameters } = payload;
  const logger4 = LoggerImport7.scope(`infra/extension-connector/connector/desktop/sqlTunnelEnforceGetOne`);
  return await sqlTunnelGet(payload).then(({ result }) => {
    if (result.length > 1) {
      logger4.warning("got more than one response from DB to sqlTunnelEnforceGetOne query", {
        parameters,
        result
      });
    }
    if (result.length === 0) {
      logger4.error(`got no results from DB to sqlTunnelEnforceGetOne query`, {
        parameters,
        result
      });
      throw new Error(`got no results from DB to sqlTunnelEnforceGetOne with params ${JSON.stringify(parameters)}`);
    }
    return result[0];
  });
}
async function getEnvironmentVariable(payload) {
  return await sendMessage({
    type: "getEnvironmentVariable",
    payload
  });
}
async function createSSOWindow(payload, timeout) {
  return await sendMessage({
    type: "createSSOWindow",
    payload,
    timeout
  });
}
async function changeWindowsVisibility(payload) {
  return await sendMessage({
    type: "changeWindowsVisibility",
    payload
  });
}
async function triggerAdapterRefresh(isNewRefresh) {
  return await sendMessage({
    type: "triggerAdapterRefresh",
    payload: { isNewRefresh }
  });
}
async function getFileInfoByPID(pid) {
  return await sendMessage({
    type: "getFileVersionByPID",
    payload: { pid },
    timeout: 6e4
  });
}
async function modifyEcwPlugin(overridePluginSettings, isMonitor) {
  return await sendMessage({
    type: "modifyEcwPlugin",
    payload: { overridePluginSettings, isMonitor }
  });
}
async function addIncognitoToExtension(chromeProfile, isMonitor) {
  return await sendMessage({
    type: "addIncognitoToExtension",
    payload: { chromeProfile, isMonitor }
  });
}
async function isProcessRunningByName(processName) {
  return await sendMessage({
    type: "isProcessRunningByName",
    payload: { processName }
  });
}
async function getChromeProfiles() {
  return await sendMessage({
    type: "getChromeProfiles"
  });
}
async function win32ExtractEcwEncryptionKey(payload) {
  return await sendAndReceiveDataFromWin32({
    event: "extract_ecw_encryption_key",
    payload
  });
}
async function win32DecodeEcwPassword(payload) {
  return await sendAndReceiveDataFromWin32({
    event: "decode_ecw_password",
    payload
  });
}
async function setTrayState(payload) {
  sendAsyncMessage({
    type: "setTrayState",
    payload
  });
}
async function win32GetChildValues(payload) {
  return await sendAndReceiveDataFromWin32({
    event: "get_child_values",
    payload
  });
}
async function injectDllToProcessElectorn(payload) {
  if (!await versionSupportsDllInjectionIdentifier() && payload?.identifier) {
    delete payload.identifier;
  }
  return await sendMessage({
    type: "injectDLL",
    payload
  });
}
function closeEhrWindows(payload) {
  sendAsyncMessage({ type: "closeEhrWindows", payload });
}
async function getActiveWindow() {
  return await sendMessage({
    type: "getActiveWindow"
  });
}
async function enableVimOSInteraction() {
  return await sendMessage({
    type: "enableVimOSInteraction"
  });
}
async function disableVimOSInteraction() {
  return await sendMessage({
    type: "disableVimOSInteraction"
  });
}
async function getActiveWindowDetails() {
  return await sendMessage({
    type: "getActiveWindowDetails"
  });
}
function fetchThroughNode(payload) {
  return sendMessage({
    type: "fetchThroughNode",
    payload: {
      resultType: "text",
      ...payload
    }
  });
}
function fetchBase64ThroughNode(payload) {
  return sendMessage({
    type: "fetchThroughNode",
    payload: {
      resultType: "base64",
      ...payload
    }
  });
}
function getOsVersion() {
  return sendMessage({
    type: "getOsVersion"
  });
}
function getComputerIdleState(idleMinimumTimeInSec = 15 * 60) {
  return sendMessage({
    type: "getComputerIdleState",
    payload: { idleMinimumTimeInSec }
  });
}
async function win32GetDomElement(payload) {
  return await sendAndReceiveDataFromWin32({
    event: "get_dom_element",
    payload
  });
}
async function Win32GetIeWindowUrl(payload) {
  return await sendAndReceiveDataFromWin32({
    event: "get_ie_window_url",
    payload
  });
}
function sendMessageToAntiProxy(payload) {
  return sendMessage({
    type: "sendMessageToAntiProxy",
    payload
  });
}
function sendMessageToIpcAsync(payload) {
  return sendMessage({
    type: "sendMessageToIpcAsync",
    payload
  });
}
function getAllEhrCookiesAsync(channel, messageId) {
  const logger4 = LoggerImport7.scope(`infra/extension-connector/connector/desktop/getAllEhrCookiesAsync`);
  const messageToSend = {
    type: "data",
    data: {
      event: "get_all_cookies",
      payload: {},
      metadata: {
        id: messageId
      }
    }
  };
  sendMessageToIpcAsync({
    messageToSend,
    channel
  }).catch((error) => {
    logger4.error("Sending message failed!", { error });
  });
  return messageId;
}
function getAllEhrCookies() {
  return sendMessageToAntiProxy({
    messageToSend: {
      type: "data",
      data: {
        event: "get_all_cookies",
        payload: {},
        metadata: {
          id: uuid2()
        }
      }
    }
  });
}
function sendDoneGracefulShutdown() {
  sendAsyncMessage({
    type: "doneGracefulShutdown"
  });
}
async function sendAndReceiveMfcData(payload) {
  return await sendMessage({
    type: "sendAndReceiveMfcData",
    payload: payload || {}
  });
}
async function sendAndReceiveDataFromNextGen(payload) {
  const response = await sendMessage({
    type: "sendAndReceiveNextGenOperations",
    payload
  });
  if (response.opType !== payload.opType) {
    throw new Error(`Unexpected operation type: ${response.opType}`);
  }
  if (!("result" in response.payload)) {
    throw new Error(`NextGen operation missing result field`);
  }
  return response.payload;
}
async function nextGenGetEncounter(params) {
  const response = await sendAndReceiveDataFromNextGen({
    pid: params.pid,
    opType: "get_encounter_diagnosis" /* GET_ENCOUNTER_DIAGNOSIS */,
    params: params.params
  });
  return response.result;
}
async function nextGenSetEncounter(params) {
  const response = await sendAndReceiveDataFromNextGen({
    pid: params.pid,
    opType: "set_encounter_diagnosis" /* SET_ENCOUNTER_DIAGNOSIS */,
    params: params.params
  });
  return response.result;
}
async function nextGenCheckEncounterDrugInteractions(params) {
  const response = await sendAndReceiveDataFromNextGen({
    pid: params.pid,
    opType: "check_encounter_drug_interactions" /* CHECK_ENCOUNTER_DRUG_INTERACTIONS */,
    params: params.params
  });
  return response.result;
}
async function nextGenSearchDiagnosis(params) {
  const response = await sendAndReceiveDataFromNextGen({
    pid: params.pid,
    opType: "search_diagnosis" /* SEARCH_DIAGNOSIS */,
    params: params.params
  });
  return response.result;
}
async function nextGenGetDBCredentials(params) {
  const response = await sendAndReceiveDataFromNextGen({
    pid: params.pid,
    opType: "get_db_connection_string" /* GET_DB_CREDENTIALS */,
    params: {}
  });
  return response.result;
}
async function nextGenCreateEncounterDocument(params) {
  const response = await sendAndReceiveDataFromNextGen({
    pid: params.pid,
    opType: "export_document" /* CREATE_ENCOUNTER_DOCUMENT */,
    params: params.params
  });
  return response.result;
}
async function sendAndReceiveDataFromFlexgridDll(payload) {
  return await sendMessage({
    type: "sendAndReceiveDataFromFlexgridDll",
    payload: payload || {},
    ehrInstanceId: payload.ehrInstanceId
  });
}
var getFlexgridValues = (windowHandle) => {
  return sendAndReceiveDataFromFlexgridDll({
    message: {
      event: "Get",
      message_id: uuid2(),
      window_handle: windowHandle
    }
  });
};
var setFlexgridValues = (windowHandle, element) => {
  return sendAndReceiveDataFromFlexgridDll({
    message: {
      event: "Update",
      element,
      message_id: uuid2(),
      window_handle: windowHandle
    }
  });
};
async function getNextgenStatusBarData(pid, windowHandle) {
  const payload = {
    event: "Get",
    message_id: uuid2(),
    window_handle: Number(windowHandle).toString(16),
    element: { type: "Grid", id: "referral-reason-grid" }
  };
  const { element, status } = await sendAndReceiveMfcData({
    message: payload,
    pid
  });
  return status === "SUCCESS" ? element[4] : "";
}
async function win32ExtractEcwEncryptionKeyV305(payload) {
  return await sendAndReceiveDataFromWin32({
    event: "extract_ecw_encryption_key_v305",
    payload
  });
}
async function win32DecodeEcwPasswordV305(payload) {
  return await sendAndReceiveDataFromWin32({
    event: "decode_ecw_password_v305",
    payload
  });
}
async function startIntegrationTool({
  toolName,
  env,
  handler
}) {
  return await sendMessageWithHandler({
    type: "startIntegrationTool",
    payload: { toolName, env },
    handler
  });
}
async function stopIntegrationTool({
  toolName,
  forcedExit
}) {
  return await sendMessage({
    type: "stopIntegrationTool",
    payload: { toolName, forcedExit }
  });
}
var sockets = {
  connect(id) {
    return sendMessage({
      type: "sockets.connect",
      payload: { id }
    });
  },
  destroy(id) {
    return sendMessage({
      type: "sockets.destroy",
      payload: { id }
    });
  },
  send(id, data) {
    return sendMessage({
      type: "sockets.send",
      payload: { id, data }
    });
  },
  on(id, event, handler) {
    return sendMessageWithHandler({
      type: "sockets.on",
      payload: { id, event },
      handler
    });
  }
};
var injectDesktopInlineWidget = (payload) => sendMessage({
  type: "injectWidget",
  payload
});
var getImageVersionByImageName = (payload) => {
  return sendMessage({
    type: "getImageVersionByImageName",
    payload
  });
};
var shouldLockToLTS = () => {
  return sendMessage({
    type: "shouldLockToLTS"
  });
};
var uploadFile = defineMessage("uploadFile");
var readDirectory = defineMessage("readDirectory");
var createBrowserWindow = defineMessage("createBrowserWindow");
var destroyBrowserWindow = defineMessage("destroyBrowserWindow");
var invokeBrowserWindowMethod = defineMessage("invokeBrowserWindowMethod");
var addBrowserWindowEventListener = (payload, handler) => {
  return sendMessageWithHandler({
    type: "addBrowserWindowEventListener",
    payload,
    handler
  });
};
var getBrowserWindowDetails = defineMessage("getBrowserWindowDetails");
var getTaskListByProcessList = async ({ processList }) => {
  return await sendMessage({
    type: "getTaskListByProcessList",
    payload: { processList }
  });
};
async function getFileContentsById(params) {
  const payload = {
    opType: "get" /* GET */,
    fileId: params.fileId
  };
  const response = await sendMessage({
    type: "fileManagerOperation",
    payload
  });
  if (response.opType !== "get" /* GET */) {
    throw new Error(`Unexpected operation type: ${response.opType}`);
  }
  return response.payload.result;
}
async function removeFile(params) {
  const payload = {
    opType: "remove" /* REMOVE */,
    fileId: params.fileId
  };
  const response = await sendMessage({
    type: "fileManagerOperation",
    payload
  });
  if (response.opType !== "remove" /* REMOVE */) {
    const logger4 = LoggerImport7.scope(`infra/extension-connector/connector/desktop/removeFile`);
    logger4.warning("Unexpected operation type", { opType: response.opType, noPHI: true });
  }
  return;
}

// src/desktop/state/anti-proxy-pipes.ts
import { logger as loggerImport } from "@getvim/vim-connect-logger";
var antiProxyPipes = /* @__PURE__ */ new Map();
var logger3 = loggerImport.scope("anti-proxy-pipe-state");
var pipeExists = (listenerId) => {
  return antiProxyPipes.has(listenerId);
};
var addAntiProxyPipeToState = (state) => {
  if (!pipeExists(state.pid)) {
    logger3.info("creating anti-proxy pipe", { pid: state.pid });
    antiProxyPipes.set(state.pid, state.remove);
  } else {
    logger3.warning("add anti-proxy pipe was called but pipe already exists", { pid: state.pid });
  }
};
var disconnectAntiProxyPipe = (pid) => {
  if (pipeExists(pid)) {
    logger3.info("disconnecting anti-proxy pipe", { pid });
    const removeFunction = antiProxyPipes.get(pid);
    if (removeFunction) {
      removeFunction();
    }
    antiProxyPipes.delete(pid);
  } else {
    logger3.warning(`disconnect anti-proxy pipe was called with pid that. doesn't exist!`, { pid });
  }
};

// src/web/index.ts
var web_exports = {};
__export(web_exports, {
  Console: () => Console,
  IconType: () => IconType,
  LogLevel: () => LogLevel,
  addAjaxRequestListener: () => addAjaxRequestListener,
  addEventListener: () => addEventListener,
  addOpenedTabsMessageListener: () => addOpenedTabsMessageListener,
  addWebRequestListener: () => addWebRequestListener,
  addXhrListener: () => addXhrListener,
  angularGetScope: () => angularGetScope,
  angularGetService: () => angularGetService,
  angularInvokeOnScope: () => angularInvokeOnScope,
  angularInvokeOnService: () => angularInvokeOnService,
  angularSetScope: () => angularSetScope,
  backboneGetModel: () => backboneGetModel,
  backboneInvoke: () => backboneInvoke,
  callJQueryAjax: () => callJQueryAjax,
  changeValue: () => changeValue,
  chromeCreatePopup: () => chromeCreatePopup,
  chromeCreateTab: () => chromeCreateTab,
  chromeRemovePopup: () => chromeRemovePopup,
  chromeSetBrowserAction: () => chromeSetBrowserAction,
  copyToClipboard: () => copyToClipboard,
  decryptECWStringByKey: () => decryptECWStringByKey,
  disconnectObserver: () => disconnectObserver,
  dispatchEvent: () => dispatchEvent,
  dispatchMouseEvent: () => dispatchMouseEvent,
  eventBusInitialized: () => eventBusInitialized,
  extensionVersion: () => extensionVersion,
  fetchData: () => fetchData,
  getActiveTab: () => getActiveTab,
  getAttribute: () => getAttribute,
  getCurrentUrl: () => getCurrentUrl,
  getInstallationType: () => getInstallationType,
  getLastLoginRequest: () => getLastLoginRequest,
  getLocalStorageKey: () => getLocalStorageKey,
  getPopupTabUrl: () => getPopupTabUrl,
  getSsoContent: () => getSsoContent,
  injectWidget: () => injectWidget,
  insertElement: () => insertElement,
  invokeFunction: () => invokeFunction,
  invokeFunctionWithCachedParams: () => invokeFunctionWithCachedParams,
  jqueryInvokeFunction: () => jqueryInvokeFunction,
  listenToDataFromWidgets: () => listenToDataFromWidgets,
  logger: () => logger2,
  modifyWidget: () => modifyWidget,
  observeMutations: () => observeMutations,
  overrideGlobalFunction: () => overrideGlobalFunction,
  removeAjaxRequestListener: () => removeAjaxRequestListener,
  removeListener: () => removeListener,
  removeLocalStorageKey: () => removeLocalStorageKey,
  removeOpenedTabsMessageListener: () => removeOpenedTabsMessageListener,
  removeWebRequestListener: () => removeWebRequestListener,
  removeWidget: () => removeWidget,
  removeXhrListener: () => removeXhrListener,
  scrape: () => scrape,
  scrapeFirst: () => scrapeFirst,
  scrapeInnerHtml: () => scrapeInnerHtml,
  scrapeParent: () => scrapeParent,
  sendDataToWidget: () => sendDataToWidget,
  sendExtensionLog: () => sendExtensionLog,
  sendPopupDetails: () => sendPopupDetails,
  sendUserDetails: () => sendUserDetails,
  sessionStorageGet: () => sessionStorageGet,
  setAttribute: () => setAttribute,
  setCurrentUrl: () => setCurrentUrl,
  setLocalStorageKey: () => setLocalStorageKey,
  slateJSAppendText: () => slateJSAppendText,
  storageGet: () => storageGet,
  storageRemove: () => storageRemove,
  storageSet: () => storageSet,
  updateElement: () => updateElement,
  vimIdSelector: () => vimIdSelector,
  webPageUnstable: () => webPageUnstable
});

// src/web/connectors.ts
import { Standard as Standard2 } from "@getvim/vim-connect";
import { omit } from "lodash-es";
var WebConnectorMessageTypes = Standard2.Connectors.Web.WebConnectorMessageTypes;
var VIM_ID_ATTRIBUTE_NAME = "data-vim-id";
var extensionVersion = async () => sendMessage({ type: WebConnectorMessageTypes.extensionVersion });
var getActiveTab = async () => sendMessage({ type: WebConnectorMessageTypes.getActiveTab });
var decryptECWStringByKey = async ({
  encryptedString,
  encryptionStorageKey
}) => sendMessage({
  type: WebConnectorMessageTypes.decryptECWStringByKey,
  payload: { encryptedString, encryptionStorageKey }
});
var getLastLoginRequest = async () => sendMessage({ type: WebConnectorMessageTypes.getLastLoginRequest });
var sendUserDetails = async (payload) => sendMessage({ type: WebConnectorMessageTypes.sendUserDetails, payload });
var sendPopupDetails = (payload) => {
  sendMessage({ type: WebConnectorMessageTypes.sendPopupDetails, payload }).catch(void 0);
};
async function addEventListener(input) {
  const listenerId = await sendMessageWithHandler({
    type: "addEventListener",
    payload: omit(input, "handler"),
    handler: input?.handler
  });
  return listenerId ? { remove: () => removeListener({ listenerId }), listenerId } : false;
}
async function observeMutations({
  selector,
  frameSelector,
  options,
  handler,
  persist
}) {
  const observerId = await sendMessageWithHandler({
    type: "observeMutations",
    payload: { selector, frameSelector, options, persist },
    handler
  });
  return observerId ? { disconnect: () => disconnectObserver({ observerId }), observerId } : void 0;
}
function disconnectObserver({ observerId }) {
  return sendMessage({
    type: "disconnectObserver",
    payload: { observerId }
  });
}
function fetchData(payload) {
  return sendMessage({
    type: "fetchData",
    payload
  });
}
async function callJQueryAjax(ajaxOptions) {
  return sendMessage({
    type: WebConnectorMessageTypes.callJQueryAjax,
    payload: ajaxOptions
  });
}
function insertElement({ selector, frameSelector, html }) {
  return sendMessage({
    type: "insertElement",
    payload: { selector, frameSelector, html }
  });
}
function getAttribute({ selector, frameSelector, path }) {
  return sendMessage({
    type: "getAttribute",
    payload: { selector, frameSelector, path }
  });
}
function setAttribute({ path, data }) {
  return sendMessage({
    type: "setAttribute",
    payload: { path, data }
  });
}
function getLocalStorageKey({ key }) {
  return sendMessage({
    type: "getLocalStorageKey",
    payload: { key }
  });
}
function setLocalStorageKey({ key, value }) {
  return sendMessage({
    type: "setLocalStorageKey",
    payload: { key, value }
  });
}
function removeLocalStorageKey({ key }) {
  return sendMessage({
    type: "removeLocalStorageKey",
    payload: { key }
  });
}
function invokeFunction({
  selector,
  frameSelector,
  shadowSelector,
  actionName,
  args,
  boundToParent
}) {
  return sendMessage({
    type: WebConnectorMessageTypes.invokeFunction,
    payload: { selector, frameSelector, shadowSelector, actionName, args, boundToParent }
  });
}
function jqueryInvokeFunction({
  selector,
  frameSelector,
  pathToAction,
  payload
}) {
  return sendMessage({
    type: WebConnectorMessageTypes.jqueryInvokeFunction,
    payload: { selector, frameSelector, pathToAction, payload }
  });
}
function scrape({
  selector,
  frameSelector,
  shadowSelector
}) {
  return sendMessage({
    type: WebConnectorMessageTypes.scrape,
    payload: { selector, frameSelector, shadowSelector }
  });
}
function scrapeFirst({
  selector,
  frameSelector,
  shadowSelector
}) {
  return sendMessage({
    type: WebConnectorMessageTypes.scrapeFirst,
    payload: { selector, frameSelector, shadowSelector }
  });
}
function scrapeInnerHtml({
  selector,
  frameSelector
}) {
  return sendMessage({
    type: WebConnectorMessageTypes.scrapeInnerHtml,
    payload: { selector, frameSelector }
  });
}
function scrapeParent({
  selector,
  frameSelector
}) {
  return sendMessage({
    type: WebConnectorMessageTypes.scrapeParent,
    payload: { selector, frameSelector }
  });
}
function updateElement(payload) {
  return sendMessage({
    type: "updateElement",
    payload
  });
}
async function changeValue({
  selector,
  frameSelector,
  value
}) {
  return sendMessage({
    type: WebConnectorMessageTypes.changeValue,
    payload: { selector, frameSelector, value }
  });
}
async function dispatchEvent({
  selector,
  frameSelector,
  shadowSelector,
  event
}) {
  return sendMessage({
    type: WebConnectorMessageTypes.dispatchEvent,
    payload: { selector, frameSelector, shadowSelector, event }
  });
}
async function dispatchMouseEvent({
  selector,
  frameSelector,
  event,
  eventOptions
}) {
  return sendMessage({
    type: WebConnectorMessageTypes.dispatchMouseEvent,
    payload: { selector, frameSelector, event, eventOptions }
  });
}
function backboneGetModel({
  selector,
  frameSelector,
  all,
  mapping
}) {
  return sendMessage({
    type: "backboneGetModel",
    payload: { selector, frameSelector, all, mapping }
  });
}
function backboneInvoke(payload) {
  return sendMessage({
    type: "backboneInvoke",
    payload
  });
}
function angularGetScope({
  selector,
  frameSelector,
  mapping
}) {
  return sendMessage({
    type: "angularGetScope",
    payload: { selector, frameSelector, mapping }
  });
}
function angularSetScope({
  selector,
  frameSelector,
  propertyPath,
  propertyValue
}) {
  return sendMessage({
    type: "angularSetScope",
    payload: { selector, frameSelector, propertyPath, propertyValue }
  });
}
function angularGetService({ selector, frameSelector, service }) {
  return sendMessage({
    type: "angularGetService",
    payload: { selector, frameSelector, service }
  });
}
function angularInvokeOnScope({
  selector,
  frameSelector,
  func,
  args
}) {
  return sendMessage({
    type: "angularInvokeOnScope",
    payload: { selector, frameSelector, func, args }
  });
}
function angularInvokeOnService({
  selector,
  frameSelector,
  service,
  func,
  args
}) {
  return sendMessage({
    type: "angularInvokeOnService",
    payload: { selector, frameSelector, service, func, args }
  });
}
async function addWebRequestListener({ urlPattern, handler }) {
  const listenerId = await sendMessageWithHandler({
    type: "addWebRequestListener",
    payload: omit({ urlPattern, handler }, "handler"),
    handler
  });
  return listenerId ? { remove: () => removeWebRequestListener({ listenerId }), listenerId } : false;
}
function chromeCreateTab(payload) {
  return sendMessage({
    type: "chromeCreateTab",
    payload
  });
}
function chromeCreatePopup(payload) {
  return sendMessage({
    type: "chromeCreatePopup",
    payload
  });
}
function chromeRemovePopup(payload) {
  return sendMessage({
    type: "chromeRemovePopup",
    payload
  });
}
function getPopupTabUrl(payload) {
  return sendMessage({
    type: "getPopupTabUrl",
    payload
  });
}
function chromeSetBrowserAction(payload) {
  return sendMessage({
    type: "chromeSetBrowserAction",
    payload
  });
}
function getSsoContent(payload) {
  return sendMessage({
    type: "getSsoContent",
    payload
  });
}
function getCurrentUrl(payload = {}) {
  return sendMessage({
    type: "getCurrentUrl",
    payload
  });
}
function setCurrentUrl(payload) {
  return sendMessage({
    type: "setCurrentUrl",
    payload
  });
}
var addOpenedTabsMessageListener = ({
  handler,
  event,
  traceId
}) => sendMessageWithHandler({
  type: "addOpenedTabsMessageListener",
  payload: { event, traceId },
  handler
});
var removeOpenedTabsMessageListener = (listenerId) => {
  return sendMessage({
    type: "removeOpenedTabsMessageListener",
    payload: { listenerId }
  });
};
function eventBusInitialized() {
  return sendAsyncMessage({
    type: WebConnectorMessageTypes.eventBusInitialized
  });
}
function webPageUnstable(input) {
  return sendAsyncMessage({
    type: WebConnectorMessageTypes.webPageUnstable,
    payload: input
  });
}
async function addXhrListener(payload) {
  const { handler } = payload;
  const listenerId = await sendMessageWithHandler({
    type: "addXhrListener",
    payload: omit(payload, "handler"),
    handler
  });
  return listenerId ? { remove: () => removeXhrListener({ listenerId }), listenerId } : false;
}
async function addAjaxRequestListener(input) {
  const { handler } = input;
  const listenerId = await sendMessageWithHandler({
    type: "addAjaxRequestListener",
    payload: omit(input, "handler"),
    handler
  });
  return listenerId ? { remove: () => removeAjaxRequestListener({ listenerId }), listenerId } : false;
}
async function overrideGlobalFunction(input) {
  return sendMessage({
    type: "overrideGlobalFunction",
    payload: input
  });
}
var vimIdSelector = (id) => `[${VIM_ID_ATTRIBUTE_NAME}="${id}"]`;
var sessionStorageGet = (key) => {
  return sendMessage({
    type: "sessionStorageGet",
    payload: { key }
  });
};
var getInstallationType = async () => sendMessage({ type: WebConnectorMessageTypes.getInstallationType });
function invokeFunctionWithCachedParams({
  selector,
  frameSelector,
  shadowSelector,
  isCacheResult,
  actions
}) {
  return sendMessage({
    type: WebConnectorMessageTypes.invokeFunctionWithCachedParams,
    payload: { selector, frameSelector, shadowSelector, isCacheResult, actions }
  });
}
function slateJSAppendText({
  selector,
  frameSelector,
  text
}) {
  return sendMessage({
    type: "slateJSAppendText",
    payload: { selector, frameSelector, text }
  });
}

// src/web/types.ts
var IconType = /* @__PURE__ */ ((IconType2) => {
  IconType2[IconType2["VIM_NORMAL"] = 0] = "VIM_NORMAL";
  IconType2[IconType2["VIM_GRAYSCALE"] = 1] = "VIM_GRAYSCALE";
  IconType2[IconType2["VIM_YELLOW"] = 2] = "VIM_YELLOW";
  return IconType2;
})(IconType || {});
export {
  common_exports as CommonConnector,
  desktop_exports as DesktopConnector,
  messaging_exports as Messaging,
  web_exports as WebConnector,
  parentChannelProvider
};
//# sourceMappingURL=index.js.map
